var $fQDDo$react = require("react");
var $fQDDo$muimaterialBackdrop = require("@mui/material/Backdrop");
var $fQDDo$reactjsxruntime = require("react/jsx-runtime");
var $fQDDo$reactvisibilitysensor = require("react-visibility-sensor");
var $fQDDo$styledcomponents = require("styled-components");
var $fQDDo$muimaterialGrid = require("@mui/material/Grid");
var $fQDDo$muimaterialTooltip = require("@mui/material/Tooltip");
var $fQDDo$muimaterialButton = require("@mui/material/Button");
var $fQDDo$muimaterialCircularProgress = require("@mui/material/CircularProgress");
var $fQDDo$lodashget = require("lodash.get");
var $fQDDo$muimaterialFormControlLabel = require("@mui/material/FormControlLabel");
var $fQDDo$muimaterialSwitch = require("@mui/material/Switch");
var $fQDDo$muimaterialSvgIcon = require("@mui/material/SvgIcon");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "AcceptCookiesModal", {
    enumerable: true,
    get: function get() {
        return $1286104da1c1ef10$exports.AcceptCookiesModal;
    }
});
var $1286104da1c1ef10$exports = {};
"use strict";
function $1286104da1c1ef10$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1286104da1c1ef10$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1286104da1c1ef10$var$_typeof(o);
}
Object.defineProperty($1286104da1c1ef10$exports, "__esModule", {
    value: true
});
$1286104da1c1ef10$exports.AcceptCookiesModal = void 0;
var $4162ea33faa774c7$exports = {};
"use strict";
function $4162ea33faa774c7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4162ea33faa774c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4162ea33faa774c7$var$_typeof(o);
}
Object.defineProperty($4162ea33faa774c7$exports, "__esModule", {
    value: true
});
$4162ea33faa774c7$exports.VisibilitySensor = void 0;

var $4162ea33faa774c7$var$_react = $4162ea33faa774c7$var$_interopRequireWildcard($fQDDo$react);

var $4162ea33faa774c7$var$_reactVisibilitySensor = $4162ea33faa774c7$var$_interopRequireDefault($fQDDo$reactvisibilitysensor);
var $b50bf75d3e6387b9$exports = {};
"use strict";
Object.defineProperty($b50bf75d3e6387b9$exports, "__esModule", {
    value: true
});
$b50bf75d3e6387b9$exports.handleVisibleOnChange = void 0;
var $b50bf75d3e6387b9$var$handleVisibleOnChange = $b50bf75d3e6387b9$exports.handleVisibleOnChange = function handleVisibleOnChange(once, setActive) {
    return function(isVisible) {
        return once && isVisible && setActive(false);
    };
};



var $4162ea33faa774c7$var$_excluded = [
    "once",
    "children"
];
function $4162ea33faa774c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4162ea33faa774c7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4162ea33faa774c7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4162ea33faa774c7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $4162ea33faa774c7$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $4162ea33faa774c7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4162ea33faa774c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4162ea33faa774c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4162ea33faa774c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4162ea33faa774c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4162ea33faa774c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4162ea33faa774c7$var$_defineProperty(e, r, t) {
    return (r = $4162ea33faa774c7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4162ea33faa774c7$var$_toPropertyKey(t) {
    var i = $4162ea33faa774c7$var$_toPrimitive(t, "string");
    return "symbol" == $4162ea33faa774c7$var$_typeof(i) ? i : i + "";
}
function $4162ea33faa774c7$var$_toPrimitive(t, r) {
    if ("object" != $4162ea33faa774c7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4162ea33faa774c7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4162ea33faa774c7$var$_slicedToArray(r, e) {
    return $4162ea33faa774c7$var$_arrayWithHoles(r) || $4162ea33faa774c7$var$_iterableToArrayLimit(r, e) || $4162ea33faa774c7$var$_unsupportedIterableToArray(r, e) || $4162ea33faa774c7$var$_nonIterableRest();
}
function $4162ea33faa774c7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4162ea33faa774c7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4162ea33faa774c7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4162ea33faa774c7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4162ea33faa774c7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $4162ea33faa774c7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4162ea33faa774c7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $4162ea33faa774c7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4162ea33faa774c7$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $4162ea33faa774c7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4162ea33faa774c7$var$VisibilitySensor = $4162ea33faa774c7$exports.VisibilitySensor = function VisibilitySensor(_ref) {
    var _ref$once = _ref.once, once = _ref$once === void 0 ? false : _ref$once, _children = _ref.children, theRest = $4162ea33faa774c7$var$_objectWithoutProperties(_ref, $4162ea33faa774c7$var$_excluded);
    var _useState = (0, $4162ea33faa774c7$var$_react.useState)(true), _useState2 = $4162ea33faa774c7$var$_slicedToArray(_useState, 2), active = _useState2[0], setActive = _useState2[1];
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4162ea33faa774c7$var$_reactVisibilitySensor["default"], $4162ea33faa774c7$var$_objectSpread($4162ea33faa774c7$var$_objectSpread({
        active: active,
        onChange: (0, $b50bf75d3e6387b9$exports.handleVisibleOnChange)(once, setActive)
    }, theRest), {}, {
        children: function children(_ref2) {
            var isVisible = _ref2.isVisible;
            return _children({
                isVisible: isVisible
            });
        }
    }));
};


var $ce2faf26ff7c2977$exports = {};
"use strict";
Object.defineProperty($ce2faf26ff7c2977$exports, "__esModule", {
    value: true
});
Object.defineProperty($ce2faf26ff7c2977$exports, "CookieMessage", {
    enumerable: true,
    get: function get() {
        return $a9067361c29dd1b9$exports.CookieMessage;
    }
});
var $a9067361c29dd1b9$exports = {};
"use strict";
Object.defineProperty($a9067361c29dd1b9$exports, "__esModule", {
    value: true
});
$a9067361c29dd1b9$exports.CookieMessage = void 0;
var $cc328f81773e9021$exports = {};
"use strict";
function $cc328f81773e9021$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cc328f81773e9021$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cc328f81773e9021$var$_typeof(o);
}
Object.defineProperty($cc328f81773e9021$exports, "__esModule", {
    value: true
});
$cc328f81773e9021$exports.Grid = void 0;

var $cc328f81773e9021$var$_react = $cc328f81773e9021$var$_interopRequireDefault($fQDDo$react);

var $cc328f81773e9021$var$_styledComponents = $cc328f81773e9021$var$_interopRequireDefault($fQDDo$styledcomponents);

var $cc328f81773e9021$var$_Grid = $cc328f81773e9021$var$_interopRequireDefault($fQDDo$muimaterialGrid);

var $cc328f81773e9021$var$_excluded = [
    "inline",
    "spacing",
    "spacingTop",
    "spacingLeft",
    "spacingRight",
    "spacingBottom",
    "xsSpacing",
    "xsSpacingTop",
    "xsSpacingLeft",
    "xsSpacingRight",
    "xsSpacingBottom",
    "mdSpacing",
    "mdSpacingTop",
    "mdSpacingLeft",
    "mdSpacingRight",
    "mdSpacingBottom",
    "mdUpSpacing",
    "mdUpSpacingTop",
    "mdUpSpacingLeft",
    "mdUpSpacingRight",
    "mdUpSpacingBottom",
    "mdDownSpacing",
    "mdDownSpacingTop",
    "mdDownSpacingLeft",
    "mdDownSpacingRight",
    "mdDownSpacingBottom",
    "lgSpacing",
    "lgSpacingTop",
    "lgSpacingLeft",
    "lgSpacingRight",
    "lgSpacingBottom",
    "xsDirection",
    "mdDirection",
    "mdUpDirection",
    "mdDownDirection",
    "lgDirection",
    "xsAlignItems",
    "mdAlignItems",
    "mdUpAlignItems",
    "mdDownAlignItems",
    "lgAlignItems",
    "xsJustify",
    "mdJustify",
    "mdUpJustify",
    "mdDownJustify",
    "lgJustify",
    "fullWidth"
];
var $cc328f81773e9021$var$_templateObject;
function $cc328f81773e9021$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $cc328f81773e9021$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc328f81773e9021$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc328f81773e9021$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cc328f81773e9021$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc328f81773e9021$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cc328f81773e9021$var$_defineProperty(e, r, t) {
    return (r = $cc328f81773e9021$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cc328f81773e9021$var$_toPropertyKey(t) {
    var i = $cc328f81773e9021$var$_toPrimitive(t, "string");
    return "symbol" == $cc328f81773e9021$var$_typeof(i) ? i : i + "";
}
function $cc328f81773e9021$var$_toPrimitive(t, r) {
    if ("object" != $cc328f81773e9021$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cc328f81773e9021$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cc328f81773e9021$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $cc328f81773e9021$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $cc328f81773e9021$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $cc328f81773e9021$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $cc328f81773e9021$var$SPACE_MULTIPLIER = 5;
var $cc328f81773e9021$var$spaceInPixels = function spaceInPixels(space) {
    return "".concat((space === true ? 1 : Number(space)) * $cc328f81773e9021$var$SPACE_MULTIPLIER, "px");
};
/**
 * check https://material-ui.com/api/grid/ for Grid props
 * - xs is for xs and higher
 * - md is for md and higher
 * - lg is for lg and higher
 *
 * we have added the following props where we use 3 variants for each breakpoint (md, mdUp, mdDown)
 * - spacing is for all viewports (this is supported by Grid, but we are overriding the default behavior)
 * - xsSpacing is for only xs (mobile)
 * - mdSpacing is for only md (tablet)
 * - mdUpSpacing is for md and higher (tablet and higher)
 * - mdDownSpacing is for md and lower (tablet and lower)
 * - lgSpacing is for only lg (desktop)
 * - the same rules apply for the direction props
 *
 * currently, we don't use sm and xl
 */ var $cc328f81773e9021$var$StyledGrid = $cc328f81773e9021$exports.Grid = (0, $cc328f81773e9021$var$_styledComponents["default"])(function(_ref) {
    var inline = _ref.inline, spacing = _ref.spacing, spacingTop = _ref.spacingTop, spacingLeft = _ref.spacingLeft, spacingRight = _ref.spacingRight, spacingBottom = _ref.spacingBottom, xsSpacing = _ref.xsSpacing, xsSpacingTop = _ref.xsSpacingTop, xsSpacingLeft = _ref.xsSpacingLeft, xsSpacingRight = _ref.xsSpacingRight, xsSpacingBottom = _ref.xsSpacingBottom, mdSpacing = _ref.mdSpacing, mdSpacingTop = _ref.mdSpacingTop, mdSpacingLeft = _ref.mdSpacingLeft, mdSpacingRight = _ref.mdSpacingRight, mdSpacingBottom = _ref.mdSpacingBottom, mdUpSpacing = _ref.mdUpSpacing, mdUpSpacingTop = _ref.mdUpSpacingTop, mdUpSpacingLeft = _ref.mdUpSpacingLeft, mdUpSpacingRight = _ref.mdUpSpacingRight, mdUpSpacingBottom = _ref.mdUpSpacingBottom, mdDownSpacing = _ref.mdDownSpacing, mdDownSpacingTop = _ref.mdDownSpacingTop, mdDownSpacingLeft = _ref.mdDownSpacingLeft, mdDownSpacingRight = _ref.mdDownSpacingRight, mdDownSpacingBottom = _ref.mdDownSpacingBottom, lgSpacing = _ref.lgSpacing, lgSpacingTop = _ref.lgSpacingTop, lgSpacingLeft = _ref.lgSpacingLeft, lgSpacingRight = _ref.lgSpacingRight, lgSpacingBottom = _ref.lgSpacingBottom, xsDirection = _ref.xsDirection, mdDirection = _ref.mdDirection, mdUpDirection = _ref.mdUpDirection, mdDownDirection = _ref.mdDownDirection, lgDirection = _ref.lgDirection, xsAlignItems = _ref.xsAlignItems, mdAlignItems = _ref.mdAlignItems, mdUpAlignItems = _ref.mdUpAlignItems, mdDownAlignItems = _ref.mdDownAlignItems, lgAlignItems = _ref.lgAlignItems, xsJustify = _ref.xsJustify, mdJustify = _ref.mdJustify, mdUpJustify = _ref.mdUpJustify, mdDownJustify = _ref.mdDownJustify, lgJustify = _ref.lgJustify, fullWidth = _ref.fullWidth, rest = $cc328f81773e9021$var$_objectWithoutProperties(_ref, $cc328f81773e9021$var$_excluded);
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($cc328f81773e9021$var$_Grid["default"], $cc328f81773e9021$var$_objectSpread({}, rest));
}).attrs(function() {
    return {
        classes: {
            item: "item",
            container: "container"
        }
    };
})($cc328f81773e9021$var$_templateObject || ($cc328f81773e9021$var$_templateObject = $cc328f81773e9021$var$_taggedTemplateLiteral([
    "\n  ",
    "\n\n  &.container {\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n        ",
    "\n        ",
    "\n        ",
    "\n        ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n  }\n\n  &.item {\n    ",
    "\n\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n    ",
    "\n    \n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    @media ",
    " {\n      ",
    "\n      ",
    "\n      ",
    "\n      ",
    "\n    }\n\n    &:empty {\n      padding: 0;\n    }\n  }\n"
])), function(props) {
    return props.fullWidth && "width: 100%;";
}, function(props) {
    return props.spacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacing), ";");
}, function(props) {
    return props.spacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingTop), ";");
}, function(props) {
    return props.spacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingLeft), ";");
}, function(props) {
    return props.spacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingRight), ";");
}, function(props) {
    return props.spacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingBottom), ";");
}, function(props) {
    return props.theme.query.mobile;
}, function(props) {
    return props.xsSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacing), ";");
}, function(props) {
    return props.xsDirection && "flex-direction: ".concat(props.xsDirection, ";");
}, function(props) {
    return props.xsAlignItems && "align-items: ".concat(props.xsAlignItems, ";");
}, function(props) {
    return props.xsJustify && "justify-content: ".concat(props.xsJustify, ";");
}, function(props) {
    return props.xsSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingTop), ";");
}, function(props) {
    return props.xsSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingLeft), ";");
}, function(props) {
    return props.xsSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingRight), ";");
}, function(props) {
    return props.xsSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingBottom), ";");
}, function(props) {
    return props.theme.query.tablet;
}, function(props) {
    return props.mdSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacing), ";");
}, function(props) {
    return props.mdDirection && "flex-direction: ".concat(props.mdDirection, ";");
}, function(props) {
    return props.mdAlignItems && "align-items: ".concat(props.mdAlignItems, ";");
}, function(props) {
    return props.mdJustify && "justify-content: ".concat(props.mdJustify, ";");
}, function(props) {
    return props.mdSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingTop), ";");
}, function(props) {
    return props.mdSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingLeft), ";");
}, function(props) {
    return props.mdSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingRight), ";");
}, function(props) {
    return props.mdSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingBottom), ";");
}, function(props) {
    return props.theme.query.max.lg;
}, function(props) {
    return props.mdDownSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacing), ";");
}, function(props) {
    return props.mdDownDirection && "flex-direction: ".concat(props.mdDownDirection, ";");
}, function(props) {
    return props.mdDownAlignItems && "align-items: ".concat(props.mdDownAlignItems, ";");
}, function(props) {
    return props.mdDownJustify && "justify-content: ".concat(props.mdDownJustify, ";");
}, function(props) {
    return props.mdDownSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingTop), ";");
}, function(props) {
    return props.mdDownSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingLeft), ";");
}, function(props) {
    return props.mdDownSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingRight), ";");
}, function(props) {
    return props.mdDownSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.md;
}, function(props) {
    return props.mdUpDirection && "flex-direction: ".concat(props.mdUpDirection, ";");
}, function(props) {
    return props.mdUpSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacing), ";");
}, function(props) {
    return props.mdUpAlignItems && "align-items: ".concat(props.mdUpAlignItems, ";");
}, function(props) {
    return props.mdUpJustify && "justify-content: ".concat(props.mdUpJustify, ";");
}, function(props) {
    return props.mdUpSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingTop), ";");
}, function(props) {
    return props.mdUpSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingLeft), ";");
}, function(props) {
    return props.mdUpSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingRight), ";");
}, function(props) {
    return props.mdUpSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.lg;
}, function(props) {
    return props.lgSpacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacing), ";");
}, function(props) {
    return props.lgDirection && "flex-direction: ".concat(props.lgDirection, ";");
}, function(props) {
    return props.lgAlignItems && "align-items: ".concat(props.lgAlignItems, ";");
}, function(props) {
    return props.lgJustify && "justify-content: ".concat(props.lgJustify, ";");
}, function(props) {
    return props.lgSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingTop), ";");
}, function(props) {
    return props.lgSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingLeft), ";");
}, function(props) {
    return props.lgSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingRight), ";");
}, function(props) {
    return props.lgSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingBottom), ";");
}, function(props) {
    return props.inline && "display: inline-flex;";
}, function(props) {
    return props.spacing && "padding: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacing), ";");
}, function(props) {
    return props.spacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingTop), ";");
}, function(props) {
    return props.spacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingLeft), ";");
}, function(props) {
    return props.spacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingRight), ";");
}, function(props) {
    return props.spacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.spacingBottom), ";");
}, function(props) {
    return props.theme.query.mobile;
}, function(props) {
    return props.xsSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingTop), ";");
}, function(props) {
    return props.xsSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingLeft), ";");
}, function(props) {
    return props.xsSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingRight), ";");
}, function(props) {
    return props.xsSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.xsSpacingBottom), ";");
}, function(props) {
    return props.theme.query.tablet;
}, function(props) {
    return props.mdSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingTop), ";");
}, function(props) {
    return props.mdSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingLeft), ";");
}, function(props) {
    return props.mdSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingRight), ";");
}, function(props) {
    return props.mdSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdSpacingBottom), ";");
}, function(props) {
    return props.theme.query.max.lg;
}, function(props) {
    return props.mdDownSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingTop), ";");
}, function(props) {
    return props.mdDownSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingLeft), ";");
}, function(props) {
    return props.mdDownSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingRight), ";");
}, function(props) {
    return props.mdDownSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdDownSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.md;
}, function(props) {
    return props.mdUpSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingTop), ";");
}, function(props) {
    return props.mdUpSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingLeft), ";");
}, function(props) {
    return props.mdUpSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingRight), ";");
}, function(props) {
    return props.mdUpSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.mdUpSpacingBottom), ";");
}, function(props) {
    return props.theme.query.min.lg;
}, function(props) {
    return props.lgSpacingTop && "padding-top: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingTop), ";");
}, function(props) {
    return props.lgSpacingLeft && "padding-left: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingLeft), ";");
}, function(props) {
    return props.lgSpacingRight && "padding-right: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingRight), ";");
}, function(props) {
    return props.lgSpacingBottom && "padding-bottom: ".concat($cc328f81773e9021$var$spaceInPixels(props.lgSpacingBottom), ";");
});



var $a9067361c29dd1b9$var$_react = $a9067361c29dd1b9$var$_interopRequireDefault($fQDDo$react);
var $4bcf179a2fd6a129$exports = {};
"use strict";
Object.defineProperty($4bcf179a2fd6a129$exports, "__esModule", {
    value: true
});
$4bcf179a2fd6a129$exports.Wrapper = $4bcf179a2fd6a129$exports.Title = $4bcf179a2fd6a129$exports.Icon = $4bcf179a2fd6a129$exports.Description = $4bcf179a2fd6a129$exports.Content = $4bcf179a2fd6a129$exports.Button = void 0;
var $e970333371cd7b48$exports = {};
"use strict";
Object.defineProperty($e970333371cd7b48$exports, "__esModule", {
    value: true
});
Object.defineProperty($e970333371cd7b48$exports, "PrivacyPolicyIcon", {
    enumerable: true,
    get: function get() {
        return $178115acf65f49fa$exports.PrivacyPolicyIcon;
    }
});
var $178115acf65f49fa$exports = {};
"use strict";
Object.defineProperty($178115acf65f49fa$exports, "__esModule", {
    value: true
});
$178115acf65f49fa$exports.PrivacyPolicyIcon = void 0;

var $178115acf65f49fa$var$_react = $178115acf65f49fa$var$_interopRequireDefault($fQDDo$react);

var $178115acf65f49fa$var$_path, $178115acf65f49fa$var$_path2, $178115acf65f49fa$var$_path3, $178115acf65f49fa$var$_defs;
function $178115acf65f49fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $178115acf65f49fa$var$PrivacyPolicyIcon = $178115acf65f49fa$exports.PrivacyPolicyIcon = function PrivacyPolicyIcon(_ref) {
    var className = _ref.className, _ref$width = _ref.width, width = _ref$width === void 0 ? 79 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 86 : _ref$height;
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 79 86",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            $178115acf65f49fa$var$_path || ($178115acf65f49fa$var$_path = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("path", {
                d: "M79 14.6351C79 50.213 67.1185 76.4037 39.5089 85.9706C11.8992 76.3993 0 50.213 0 14.6351L39.5089 0L79 14.6351Z",
                fill: "url(#paint0_linear_52817_10655)"
            })),
            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("g", {
                style: {
                    mixBlendMode: "hard-light"
                },
                opacity: "0.3",
                children: $178115acf65f49fa$var$_path2 || ($178115acf65f49fa$var$_path2 = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("path", {
                    d: "M49.997 35.2772C49.997 31.2553 46.6535 28 42.4985 28C38.3435 28 35 31.2553 35 35.2772C35 39.2992 36.385 40.1202 38.5021 41.4044L36.5436 59H48.4594L46.4979 41.4044C48.615 40.1202 50 37.8776 50 35.2772H49.997Z",
                    fill: "#2E3192"
                }))
            }),
            $178115acf65f49fa$var$_path3 || ($178115acf65f49fa$var$_path3 = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("path", {
                d: "M47.9967 34.2772C47.9967 30.2553 44.4303 27 39.9984 27C35.5664 27 32 30.2553 32 34.2772C32 38.2992 33.4773 39.1202 35.7356 40.4044L33.6465 58H46.3567L44.2644 40.4044C46.5227 39.1202 48 36.8776 48 34.2772H47.9967Z",
                fill: "white"
            })),
            $178115acf65f49fa$var$_defs || ($178115acf65f49fa$var$_defs = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)("linearGradient", {
                    id: "paint0_linear_52817_10655",
                    x1: "0.270336",
                    y1: "30.904",
                    x2: "76.74",
                    y2: "55.007",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("stop", {
                            stopColor: "#AEE398"
                        }),
                        /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("stop", {
                            offset: "0.2",
                            stopColor: "#99DE7C"
                        }),
                        /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("stop", {
                            offset: "0.4",
                            stopColor: "#78C658"
                        }),
                        /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("stop", {
                            offset: "0.7",
                            stopColor: "#57B236"
                        }),
                        /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("stop", {
                            offset: "1",
                            stopColor: "#57B236"
                        })
                    ]
                })
            }))
        ]
    });
};




var $c06c31892548508b$exports = {};
"use strict";
Object.defineProperty($c06c31892548508b$exports, "__esModule", {
    value: true
});
$c06c31892548508b$exports.Button = void 0;
var $ac782590520c5221$exports = {};
"use strict";
Object.defineProperty($ac782590520c5221$exports, "__esModule", {
    value: true
});
Object.defineProperty($ac782590520c5221$exports, "ArrowToolTip", {
    enumerable: true,
    get: function get() {
        return $ed5c8fe8c49aff37$exports.ArrowToolTip;
    }
});
var $ed5c8fe8c49aff37$exports = {};
"use strict";
Object.defineProperty($ed5c8fe8c49aff37$exports, "__esModule", {
    value: true
});
$ed5c8fe8c49aff37$exports.ArrowToolTip = void 0;

var $ed5c8fe8c49aff37$var$_react = $ed5c8fe8c49aff37$var$_interopRequireDefault($fQDDo$react);

var $ed5c8fe8c49aff37$var$_Tooltip = $ed5c8fe8c49aff37$var$_interopRequireDefault($fQDDo$muimaterialTooltip);

function $ed5c8fe8c49aff37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $ed5c8fe8c49aff37$var$ArrowToolTip = $ed5c8fe8c49aff37$exports.ArrowToolTip = function ArrowToolTip(_ref) {
    var _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className;
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($ed5c8fe8c49aff37$var$_Tooltip["default"], {
        title: title,
        className: className,
        arrow: true,
        children: children
    });
};





var $c06c31892548508b$var$_react = $c06c31892548508b$var$_interopRequireDefault($fQDDo$react);
var $cac1573991102b6d$exports = {};
"use strict";
function $cac1573991102b6d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cac1573991102b6d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cac1573991102b6d$var$_typeof(o);
}
Object.defineProperty($cac1573991102b6d$exports, "__esModule", {
    value: true
});
$cac1573991102b6d$exports.sizeStyles = $cac1573991102b6d$exports.paddingStyles = $cac1573991102b6d$exports.defaultLabelStyle = $cac1573991102b6d$exports.colorStyles = $cac1573991102b6d$exports.circleProgressDisabledColorStyles = $cac1573991102b6d$exports.circleProgressColorStyles = $cac1573991102b6d$exports.buttonLoadingStyles = $cac1573991102b6d$exports.Wrapper = $cac1573991102b6d$exports.StyledCircularProgress = $cac1573991102b6d$exports.StyledButton = $cac1573991102b6d$exports.LabelWrapper = $cac1573991102b6d$exports.IconWrapper = void 0;

var $cac1573991102b6d$var$_react = $cac1573991102b6d$var$_interopRequireDefault($fQDDo$react);

var $cac1573991102b6d$var$_styledComponents = $cac1573991102b6d$var$_interopRequireWildcard($fQDDo$styledcomponents);
var $bebaee556f9a4756$exports = {};
"use strict";
Object.defineProperty($bebaee556f9a4756$exports, "__esModule", {
    value: true
});
$bebaee556f9a4756$exports.FONTS = void 0;
var $bebaee556f9a4756$var$FONTS = $bebaee556f9a4756$exports.FONTS = {
    displayXXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "62px",
        lineHeight: "150%"
    },
    displayXL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "46px",
        lineHeight: "150%"
    },
    displayL: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "34px",
        lineHeight: "150%"
    },
    displayM: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "24px",
        lineHeight: "150%"
    },
    displayS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    displayXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    displayXXS: {
        fontFamily: '"Poppins", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyL: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "18px",
        lineHeight: "180%"
    },
    bodyM: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "14px",
        lineHeight: "180%"
    },
    bodyS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "12px",
        lineHeight: "180%"
    },
    bodyXS: {
        fontFamily: '"Inter", sans-serif',
        fontSize: "10px",
        lineHeight: "180%"
    }
};


var $bb6a8a3022cc23ea$exports = {};
"use strict";
Object.defineProperty($bb6a8a3022cc23ea$exports, "__esModule", {
    value: true
});
$bb6a8a3022cc23ea$exports.viewports = $bb6a8a3022cc23ea$exports.typoSelector = $bb6a8a3022cc23ea$exports.typo = $bb6a8a3022cc23ea$exports.query = $bb6a8a3022cc23ea$exports.layer = $bb6a8a3022cc23ea$exports.gradient = $bb6a8a3022cc23ea$exports.fontWeight = $bb6a8a3022cc23ea$exports.colorSelector = $bb6a8a3022cc23ea$exports.color = $bb6a8a3022cc23ea$exports.breakpoint = $bb6a8a3022cc23ea$exports.boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadow = $bb6a8a3022cc23ea$exports.border = $bb6a8a3022cc23ea$exports.Theme = void 0;


var $bb6a8a3022cc23ea$var$_templateObject, $bb6a8a3022cc23ea$var$_templateObject2, $bb6a8a3022cc23ea$var$_templateObject3, $bb6a8a3022cc23ea$var$_templateObject4, $bb6a8a3022cc23ea$var$_templateObject5, $bb6a8a3022cc23ea$var$_templateObject6, $bb6a8a3022cc23ea$var$_templateObject7, $bb6a8a3022cc23ea$var$_templateObject8, $bb6a8a3022cc23ea$var$_templateObject9, $bb6a8a3022cc23ea$var$_templateObject10, $bb6a8a3022cc23ea$var$_templateObject11, $bb6a8a3022cc23ea$var$_templateObject12, $bb6a8a3022cc23ea$var$_templateObject13, $bb6a8a3022cc23ea$var$_templateObject14, $bb6a8a3022cc23ea$var$_templateObject15;
function $bb6a8a3022cc23ea$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $bb6a8a3022cc23ea$var$color = $bb6a8a3022cc23ea$exports.color = Object.freeze({
    p100: "#EEF7FF",
    p200: "#9AC7EF",
    p300: "#5AB1FF",
    p400: "#1D71F3",
    p500: "#1A4EC0",
    p600: "#112F86",
    a100: "#FFF6EC",
    a200: "#FFD3A5",
    a300: "#FF8932",
    a400: "#FF670A",
    a500: "#FF4D00",
    a600: "#A12A0B",
    b100: "#F0FDF1",
    b200: "#BAF8C3",
    b300: "#84F195",
    b400: "#47E160",
    b500: "#14B22E",
    b600: "#128325",
    c100: "#FDF1F2",
    c200: "#F7CAD4",
    c300: "#EE96A9",
    c400: "#DD5C75",
    c500: "#BB3853",
    c600: "#881D3F",
    d100: "#F6F4FE",
    d200: "#DFD9FB",
    d300: "#AB92F3",
    d400: "#7638DF",
    d500: "#491896",
    d600: "#30165F",
    g100: "#F6F6F8",
    g200: "#ECEEF2",
    g300: "#AEB8CB",
    g400: "#627495",
    g500: "#404B64",
    g600: "#262E41",
    e100: "#FFF1F1",
    e200: "#FFC7C5",
    e300: "#FF6A65",
    e400: "#ED2C25",
    e500: "#C7140E",
    e600: "#6D0400",
    white: "#FFFFFF",
    black: "#000000",
    facebook: "#4464a0",
    twitter: "#1da1f2",
    linkedin: "#0077b5"
});
var $bb6a8a3022cc23ea$var$colorSelector = $bb6a8a3022cc23ea$exports.colorSelector = function colorSelector(colorKey) {
    return function(props) {
        return props.theme.color[colorKey.toLowerCase()];
    };
};
var $bb6a8a3022cc23ea$var$typo = $bb6a8a3022cc23ea$exports.typo = Object.freeze(Object.keys($bebaee556f9a4756$exports.FONTS).reduce(function(acc, key) {
    acc[key] = (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject || ($bb6a8a3022cc23ea$var$_templateObject = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n      font-size: ",
        ";\n      font-family: ",
        ";\n      line-height: ",
        ";\n    "
    ])), $bebaee556f9a4756$exports.FONTS[key].fontSize, $bebaee556f9a4756$exports.FONTS[key].fontFamily, $bebaee556f9a4756$exports.FONTS[key].lineHeight);
    return acc;
}, {}));
var $bb6a8a3022cc23ea$var$typoSelector = $bb6a8a3022cc23ea$exports.typoSelector = function typoSelector(typoKey) {
    return function(props) {
        return props.theme.typo[typoKey];
    };
};
var $bb6a8a3022cc23ea$var$fontWeight = $bb6a8a3022cc23ea$exports.fontWeight = Object.freeze({
    light: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject2 || ($bb6a8a3022cc23ea$var$_templateObject2 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 300;\n  "
    ]))),
    regular: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject3 || ($bb6a8a3022cc23ea$var$_templateObject3 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 400;\n  "
    ]))),
    medium: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject4 || ($bb6a8a3022cc23ea$var$_templateObject4 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 600;\n  "
    ]))),
    bold: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject5 || ($bb6a8a3022cc23ea$var$_templateObject5 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    font-weight: 700;\n  "
    ])))
});
var $bb6a8a3022cc23ea$var$boxShadowFocus = $bb6a8a3022cc23ea$exports.boxShadowFocus = (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject6 || ($bb6a8a3022cc23ea$var$_templateObject6 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
    "\n  &:focus {\n    box-shadow: 0px 0px 10px ",
    ";\n  }\n"
])), $bb6a8a3022cc23ea$var$color.d100);
var $bb6a8a3022cc23ea$var$gradient = $bb6a8a3022cc23ea$exports.gradient = Object.freeze({
    lagoon: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject7 || ($bb6a8a3022cc23ea$var$_templateObject7 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      87.41deg,\n      ",
        " 4.03%,\n      ",
        " 95.69%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.p500, $bb6a8a3022cc23ea$var$color.p600),
    wave: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject8 || ($bb6a8a3022cc23ea$var$_templateObject8 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(236.19deg, #133599 7.5%, #05164a 86.12%);\n  "
    ]))),
    nector: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject9 || ($bb6a8a3022cc23ea$var$_templateObject9 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n      84.4deg,\n      #e00051 6.75%,\n      ",
        " 97.26%\n    );\n  "
    ])), $bb6a8a3022cc23ea$var$color.a500)
});
var $bb6a8a3022cc23ea$var$boxShadow = $bb6a8a3022cc23ea$exports.boxShadow = Object.freeze({
    level1: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject10 || ($bb6a8a3022cc23ea$var$_templateObject10 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level2: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject11 || ($bb6a8a3022cc23ea$var$_templateObject11 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level3: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject12 || ($bb6a8a3022cc23ea$var$_templateObject12 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.07);\n  "
    ]))),
    level4: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject13 || ($bb6a8a3022cc23ea$var$_templateObject13 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 14px 28px rgba(0, 0, 0, 0.1);\n  "
    ]))),
    level5: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject14 || ($bb6a8a3022cc23ea$var$_templateObject14 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 19px 38px rgba(0, 0, 0, 0.15);\n  "
    ]))),
    focus: (0, $fQDDo$styledcomponents.css)($bb6a8a3022cc23ea$var$_templateObject15 || ($bb6a8a3022cc23ea$var$_templateObject15 = $bb6a8a3022cc23ea$var$_taggedTemplateLiteral([
        "\n    box-shadow: 0px 0px 10px ",
        ";\n  "
    ])), $bb6a8a3022cc23ea$var$color.d100)
});
var $bb6a8a3022cc23ea$var$border = $bb6a8a3022cc23ea$exports.border = Object.freeze({
    level1: "0.3px solid rgba(130, 130, 130, 0.5)"
});
var $bb6a8a3022cc23ea$var$layer = $bb6a8a3022cc23ea$exports.layer = Object.freeze({
    hidden: -1,
    select: 5,
    newQuoteButton: 45,
    navbar: 50,
    tooltip: 60,
    mobileSocialFooter: 70,
    popup: 90,
    modal: 100,
    slideOut: 1101,
    welcomeModal: 1301
});
var $bb6a8a3022cc23ea$var$viewports = $bb6a8a3022cc23ea$exports.viewports = {
    mobile: {
        width: 360,
        breakpoint: "sm"
    },
    tablet: {
        width: 768,
        breakpoint: "md"
    },
    desktop: {
        width: 1200,
        breakpoint: "lg"
    }
};
// https://material-ui.com/customization/default-theme/?expend-path=$.breakpoints.values
var $bb6a8a3022cc23ea$var$breakpoint = $bb6a8a3022cc23ea$exports.breakpoint = Object.freeze({
    // this prop is needed because webapp/imports/styledComponents/Grid/Column.js uses xs viewport
    xs: 0,
    sm: 0,
    md: $bb6a8a3022cc23ea$var$viewports.tablet.width,
    lg: $bb6a8a3022cc23ea$var$viewports.desktop.width
});
// https://getbootstrap.com/docs/4.3/layout/overview/
var $bb6a8a3022cc23ea$var$query = $bb6a8a3022cc23ea$exports.query = {
    min: {
        solve: function solve(width) {
            return "(min-width: ".concat(width, "px)");
        },
        tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px)")
    },
    max: {
        solve: function solve(width) {
            return "(max-width: ".concat(width - 0.02, "px)");
        },
        tablet: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)")
    },
    mobile: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px)"),
    tablet: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md, "px) and (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.lg - 0.02, "px)"),
    desktop: "(min-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.lg, "px)"),
    dpr2x: "(min-resolution: 2dppx), (min-resolution: 192dpi)",
    mobileDpr2x: "(max-width: ".concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 2dppx), (max-width: ").concat($bb6a8a3022cc23ea$var$breakpoint.md - 0.02, "px) and (min-resolution: 192dpi)")
};
Object.keys($bb6a8a3022cc23ea$var$breakpoint).forEach(function(key) {
    $bb6a8a3022cc23ea$var$query.min[key] = $bb6a8a3022cc23ea$var$query.min.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
    $bb6a8a3022cc23ea$var$query.max[key] = $bb6a8a3022cc23ea$var$query.max.solve($bb6a8a3022cc23ea$var$breakpoint[key]);
});
Object.freeze($bb6a8a3022cc23ea$var$query);
Object.freeze($bb6a8a3022cc23ea$var$query.min);
Object.freeze($bb6a8a3022cc23ea$var$query.max);
var $bb6a8a3022cc23ea$var$Theme = $bb6a8a3022cc23ea$exports.Theme = Object.freeze({
    color: $bb6a8a3022cc23ea$var$color,
    typo: $bb6a8a3022cc23ea$var$typo,
    border: $bb6a8a3022cc23ea$var$border,
    boxShadow: $bb6a8a3022cc23ea$var$boxShadow,
    boxShadowFocus: $bb6a8a3022cc23ea$var$boxShadowFocus,
    gradient: $bb6a8a3022cc23ea$var$gradient,
    layer: $bb6a8a3022cc23ea$var$layer,
    fontWeight: $bb6a8a3022cc23ea$var$fontWeight,
    query: $bb6a8a3022cc23ea$var$query
});


var $2d4500375a8ffcbf$exports = {};
"use strict";
Object.defineProperty($2d4500375a8ffcbf$exports, "__esModule", {
    value: true
});
$2d4500375a8ffcbf$exports.get = void 0;

var $2d4500375a8ffcbf$var$_lodash = $2d4500375a8ffcbf$var$_interopRequireDefault($fQDDo$lodashget);
function $2d4500375a8ffcbf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $2d4500375a8ffcbf$var$get = $2d4500375a8ffcbf$exports.get = function get(object, path, defaultValue) {
    var lodashResult = (0, $2d4500375a8ffcbf$var$_lodash["default"])(object, path, defaultValue);
    if (lodashResult === null && defaultValue !== undefined) return defaultValue;
    return lodashResult;
};



var $cac1573991102b6d$var$_Button = $cac1573991102b6d$var$_interopRequireDefault($fQDDo$muimaterialButton);

var $cac1573991102b6d$var$_CircularProgress = $cac1573991102b6d$var$_interopRequireDefault($fQDDo$muimaterialCircularProgress);

var $cac1573991102b6d$var$_excluded = [
    "isLoading",
    "colorStyle",
    "size",
    "className",
    "disabledTooltipText",
    "isGhost"
], $cac1573991102b6d$var$_excluded2 = [
    "colorStyle",
    "disabled"
];
var $cac1573991102b6d$var$_templateObject, $cac1573991102b6d$var$_templateObject2, $cac1573991102b6d$var$_templateObject3, $cac1573991102b6d$var$_templateObject4, $cac1573991102b6d$var$_templateObject5, $cac1573991102b6d$var$_templateObject6, $cac1573991102b6d$var$_templateObject7, $cac1573991102b6d$var$_templateObject8, $cac1573991102b6d$var$_templateObject9, $cac1573991102b6d$var$_templateObject10, $cac1573991102b6d$var$_templateObject11, $cac1573991102b6d$var$_templateObject12, $cac1573991102b6d$var$_templateObject13, $cac1573991102b6d$var$_templateObject14, $cac1573991102b6d$var$_templateObject15, $cac1573991102b6d$var$_templateObject16, $cac1573991102b6d$var$_templateObject17, $cac1573991102b6d$var$_templateObject18, $cac1573991102b6d$var$_templateObject19, $cac1573991102b6d$var$_templateObject20, $cac1573991102b6d$var$_templateObject21, $cac1573991102b6d$var$_templateObject22;
function $cac1573991102b6d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($cac1573991102b6d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $cac1573991102b6d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $cac1573991102b6d$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $cac1573991102b6d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $cac1573991102b6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $cac1573991102b6d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cac1573991102b6d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cac1573991102b6d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cac1573991102b6d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cac1573991102b6d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cac1573991102b6d$var$_defineProperty(e, r, t) {
    return (r = $cac1573991102b6d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cac1573991102b6d$var$_toPropertyKey(t) {
    var i = $cac1573991102b6d$var$_toPrimitive(t, "string");
    return "symbol" == $cac1573991102b6d$var$_typeof(i) ? i : i + "";
}
function $cac1573991102b6d$var$_toPrimitive(t, r) {
    if ("object" != $cac1573991102b6d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cac1573991102b6d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cac1573991102b6d$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $cac1573991102b6d$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $cac1573991102b6d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $cac1573991102b6d$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $cac1573991102b6d$var$defaultLabelStyle = $cac1573991102b6d$exports.defaultLabelStyle = {
    textTransform: "uppercase"
};
/**
 * Based on Material-ui CircularProgress attributes
 */ var $cac1573991102b6d$var$buttonLoadingStyles = $cac1573991102b6d$exports.buttonLoadingStyles = {
    primary: {
        size: 18,
        thickness: 7
    },
    ghost: {
        size: 18,
        thickness: 7
    }
};
var $cac1573991102b6d$var$circleProgressDisabledColorStyles = $cac1573991102b6d$exports.circleProgressDisabledColorStyles = {
    primary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject || ($cac1573991102b6d$var$_templateObject = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return props.theme.color.g400;
    }),
    secondary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject2 || ($cac1573991102b6d$var$_templateObject2 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return props.theme.color.g400;
    }),
    ghost: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject3 || ($cac1573991102b6d$var$_templateObject3 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return props.theme.color.g400;
    })
};
var $cac1573991102b6d$var$circleProgressColorStyles = $cac1573991102b6d$exports.circleProgressColorStyles = {
    primary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject4 || ($cac1573991102b6d$var$_templateObject4 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.color", (0, $bb6a8a3022cc23ea$exports.colorSelector)("white"));
    }),
    secondary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject5 || ($cac1573991102b6d$var$_templateObject5 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.color", (0, $bb6a8a3022cc23ea$exports.colorSelector)("white"));
    }),
    ghost: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject6 || ($cac1573991102b6d$var$_templateObject6 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n  "
    ])), function(props) {
        return props.theme.color.p600;
    })
};
var $cac1573991102b6d$var$colorStyles = $cac1573991102b6d$exports.colorStyles = {
    primary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject7 || ($cac1573991102b6d$var$_templateObject7 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    color: ",
        ";\n    &:hover,\n    &:active,\n    &:focus,\n    &.loading {\n      background-color: ",
        ";\n    }\n    &:disabled {\n      color: ",
        ";\n      background-color: ",
        ";\n    }\n  "
    ])), function(props) {
        return props.theme.color.p500;
    }, function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.color", (0, $bb6a8a3022cc23ea$exports.colorSelector)("white"));
    }, function(props) {
        return props.theme.color.p600;
    }, function(props) {
        return props.theme.color.g400;
    }, function(props) {
        return props.theme.color.g300;
    }),
    secondary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject8 || ($cac1573991102b6d$var$_templateObject8 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n    border: 2px solid ",
        ";\n    background-color: ",
        ";\n    &:hover,\n    &:active,\n    &.loading {\n      background-color: ",
        ";\n      color: ",
        ";\n      border-color: ",
        ";\n    }\n    &:disabled {\n      color: ",
        ";\n      background-color: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.color", (0, $bb6a8a3022cc23ea$exports.colorSelector)("p500"));
    }, function(props) {
        return props.theme.color.p500;
    }, function(props) {
        return props.theme.color.white;
    }, function(props) {
        return props.theme.color.p600;
    }, function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.color", (0, $bb6a8a3022cc23ea$exports.colorSelector)("white"));
    }, function(props) {
        return props.theme.color.p600;
    }, function(props) {
        return props.theme.color.g400;
    }, function(props) {
        return props.theme.color.g300;
    }, function(props) {
        return props.theme.color.g300;
    }),
    ghost: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject9 || ($cac1573991102b6d$var$_templateObject9 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    color: ",
        ";\n    background-color: transparent;\n    &:hover,\n    &:active {\n      color: ",
        ";\n      background-color: transparent;\n    }\n    &:disabled {\n      color: ",
        ";\n    }\n    &.loading {\n      ",
        ";\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n    }\n  "
    ])), function(props) {
        return props.theme.color.p500;
    }, function(props) {
        return props.theme.color.p600;
    }, function(props) {
        return props.theme.color.g400;
    }, function(props) {
        return props.theme.gradient.lagoon;
    })
};
var $cac1573991102b6d$var$sizeStyles = $cac1573991102b6d$exports.sizeStyles = {
    ghost: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject10 || ($cac1573991102b6d$var$_templateObject10 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    height: fit-content;\n    min-width: fit-content;\n    border-radius: 0;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  "
    ])), $bebaee556f9a4756$exports.FONTS.bodyM.fontSize, $bebaee556f9a4756$exports.FONTS.bodyM.lineHeight),
    icon: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject11 || ($cac1573991102b6d$var$_templateObject11 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    height: 50px;\n    min-width: 50px;\n    border-radius: 25px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    padding: 8px;\n  "
    ])), $bebaee556f9a4756$exports.FONTS.bodyS.fontSize, $bebaee556f9a4756$exports.FONTS.bodyS.lineHeight),
    small: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject12 || ($cac1573991102b6d$var$_templateObject12 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    border-radius: ",
        "px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.borderRadius", 3);
    }, $bebaee556f9a4756$exports.FONTS.bodyS.fontSize, $bebaee556f9a4756$exports.FONTS.bodyS.lineHeight),
    medium: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject13 || ($cac1573991102b6d$var$_templateObject13 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    border-radius: ",
        "px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.borderRadius", 3);
    }, $bebaee556f9a4756$exports.FONTS.displayXS.fontSize, $bebaee556f9a4756$exports.FONTS.displayXS.lineHeight),
    large: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject14 || ($cac1573991102b6d$var$_templateObject14 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    border-radius: ",
        "px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n  "
    ])), function(props) {
        return (0, $2d4500375a8ffcbf$exports.get)(props, "theme.overrides.button.borderRadius", 3);
    }, $bebaee556f9a4756$exports.FONTS.bodyL.fontSize, $bebaee556f9a4756$exports.FONTS.bodyM.lineHeight)
};
/*
  different padding because of border to secondary button type
*/ var $cac1573991102b6d$var$paddingStyles = $cac1573991102b6d$exports.paddingStyles = {
    primary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject15 || ($cac1573991102b6d$var$_templateObject15 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    padding: 12px 16px;\n  "
    ]))),
    secondary: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject16 || ($cac1573991102b6d$var$_templateObject16 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    padding: 10px 16px;\n  "
    ]))),
    ghost: (0, $cac1573991102b6d$var$_styledComponents.css)($cac1573991102b6d$var$_templateObject17 || ($cac1573991102b6d$var$_templateObject17 = $cac1573991102b6d$var$_taggedTemplateLiteral([
        "\n    padding: 0;\n  "
    ])))
};
var $cac1573991102b6d$var$LabelWrapper = $cac1573991102b6d$exports.LabelWrapper = $cac1573991102b6d$var$_styledComponents["default"].span($cac1573991102b6d$var$_templateObject18 || ($cac1573991102b6d$var$_templateObject18 = $cac1573991102b6d$var$_taggedTemplateLiteral([
    "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  white-space: nowrap;\n"
])));
var $cac1573991102b6d$var$IconWrapper = $cac1573991102b6d$exports.IconWrapper = $cac1573991102b6d$var$_styledComponents["default"].span($cac1573991102b6d$var$_templateObject19 || ($cac1573991102b6d$var$_templateObject19 = $cac1573991102b6d$var$_taggedTemplateLiteral([
    "\n  padding-left: ",
    "px;\n  display: flex;\n"
])), function(props) {
    return props.labelValue ? 8 : 0;
});
var $cac1573991102b6d$var$Wrapper = $cac1573991102b6d$exports.Wrapper = $cac1573991102b6d$var$_styledComponents["default"].div($cac1573991102b6d$var$_templateObject20 || ($cac1573991102b6d$var$_templateObject20 = $cac1573991102b6d$var$_taggedTemplateLiteral([
    "\n  display: inline-block;\n\n  ",
    "\n\n  ",
    "\n  \n    ",
    "\n"
])), function(props) {
    return props.disabled ? "cursor: no-drop;" : "";
}, function(props) {
    return props.fullWidth && "\n        width: 100%;\n  \n        > button {\n          width: 100%;\n        }\n      ";
}, function(props) {
    return props.fullWidthOnMobile && "\n        @media ".concat(props.theme.query.mobile, " {\n          width: 100%;\n  \n          > button {\n            width: 100%;\n          }\n        }\n      ");
});
// TODO: Clean button its complete mess
var $cac1573991102b6d$var$StyledButton = $cac1573991102b6d$exports.StyledButton = (0, $cac1573991102b6d$var$_styledComponents["default"])(function(_ref) {
    var isLoading = _ref.isLoading, colorStyle = _ref.colorStyle, size = _ref.size, className = _ref.className, disabledTooltipText = _ref.disabledTooltipText, isGhost = _ref.isGhost, other = $cac1573991102b6d$var$_objectWithoutProperties(_ref, $cac1573991102b6d$var$_excluded);
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($cac1573991102b6d$var$_Button["default"], $cac1573991102b6d$var$_objectSpread($cac1573991102b6d$var$_objectSpread({}, other), {}, {
        classes: {
            // NOTE: This is for prevent blinking by rerendering
            root: [
                isLoading ? "loading" : "root",
                className
            ].join(" ").trim(),
            label: "label",
            text: "text"
        }
    }));
})($cac1573991102b6d$var$_templateObject21 || ($cac1573991102b6d$var$_templateObject21 = $cac1573991102b6d$var$_taggedTemplateLiteral([
    "\n  display: flex;\n  cursor: pointer;\n  font-family: ",
    ";\n  letter-spacing: inherit;\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  transition: all 0.4s ease-in-out;\n\n  &:focus {\n    box-shadow: none;\n  }\n\n  & > span:first-child {\n    text-transform: ",
    ";\n    ",
    "\n  }\n"
])), $bebaee556f9a4756$exports.FONTS.displayXS.fontFamily, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return $cac1573991102b6d$var$colorStyles[props.colorStyle];
}, function(props) {
    return $cac1573991102b6d$var$paddingStyles[props.colorStyle];
}, function(props) {
    return $cac1573991102b6d$var$sizeStyles[props.size];
}, function(props) {
    return props.isGhost ? "capitalize" : $cac1573991102b6d$var$defaultLabelStyle.textTransform;
}, function(props) {
    return props.isGhost && "text-decoration: underline;";
});
var $cac1573991102b6d$var$StyledCircularProgress = $cac1573991102b6d$exports.StyledCircularProgress = (0, $cac1573991102b6d$var$_styledComponents["default"])(function(_ref2) {
    var colorStyle = _ref2.colorStyle, disabled = _ref2.disabled, other = $cac1573991102b6d$var$_objectWithoutProperties(_ref2, $cac1573991102b6d$var$_excluded2);
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($cac1573991102b6d$var$_CircularProgress["default"], $cac1573991102b6d$var$_objectSpread({}, other));
})($cac1573991102b6d$var$_templateObject22 || ($cac1573991102b6d$var$_templateObject22 = $cac1573991102b6d$var$_taggedTemplateLiteral([
    "\n  &.MuiCircularProgress-root {\n    position: inherit;\n    ",
    ";\n  }\n"
])), function(props) {
    return props.disabled ? $cac1573991102b6d$var$circleProgressDisabledColorStyles[props.colorStyle] : $cac1573991102b6d$var$circleProgressColorStyles[props.colorStyle];
});


var $54a26cd9a2f0c50b$exports = {};
"use strict";
Object.defineProperty($54a26cd9a2f0c50b$exports, "__esModule", {
    value: true
});
$54a26cd9a2f0c50b$exports.renderLabel = $54a26cd9a2f0c50b$exports.renderIcon = $54a26cd9a2f0c50b$exports.getSize = $54a26cd9a2f0c50b$exports.getLoadingIcon = $54a26cd9a2f0c50b$exports.getLabelValue = void 0;

var $54a26cd9a2f0c50b$var$_react = $54a26cd9a2f0c50b$var$_interopRequireDefault($fQDDo$react);


function $54a26cd9a2f0c50b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $54a26cd9a2f0c50b$var$getLoadingIcon = $54a26cd9a2f0c50b$exports.getLoadingIcon = function getLoadingIcon(loadingIcon, colorStyle, disabled) {
    var key = loadingIcon ? null : "circular-".concat(Date.now());
    var defaultStyle = $cac1573991102b6d$exports.buttonLoadingStyles.primary;
    var circularStyle = $cac1573991102b6d$exports.buttonLoadingStyles[colorStyle] || defaultStyle;
    return loadingIcon || /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($cac1573991102b6d$exports.StyledCircularProgress, {
        id: key,
        size: circularStyle.size,
        disabled: disabled,
        colorStyle: colorStyle,
        thickness: circularStyle.thickness
    }, key);
};
var $54a26cd9a2f0c50b$var$getLabelValue = $54a26cd9a2f0c50b$exports.getLabelValue = function getLabelValue(props) {
    var children = props.children, label = props.label, loadingLabel = props.loadingLabel, isLoading = props.isLoading;
    var selectedLabel = children || label;
    return isLoading ? loadingLabel || selectedLabel : selectedLabel;
};
var $54a26cd9a2f0c50b$var$renderIcon = $54a26cd9a2f0c50b$exports.renderIcon = function renderIcon(props) {
    var _props$icon = props.icon, icon = _props$icon === void 0 ? null : _props$icon, _props$loadingIcon = props.loadingIcon, loadingIcon = _props$loadingIcon === void 0 ? null : _props$loadingIcon, _props$isLoading = props.isLoading, isLoading = _props$isLoading === void 0 ? false : _props$isLoading, _props$colorStyle = props.colorStyle, colorStyle = _props$colorStyle === void 0 ? "primary" : _props$colorStyle, disabled = props.disabled;
    var iconValue = isLoading ? $54a26cd9a2f0c50b$var$getLoadingIcon(loadingIcon, colorStyle, disabled) : icon;
    if (!iconValue) return null;
    var labelValue = $54a26cd9a2f0c50b$var$getLabelValue(props);
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($cac1573991102b6d$exports.IconWrapper, {
        labelValue: labelValue,
        children: iconValue
    });
};
var $54a26cd9a2f0c50b$var$renderLabel = $54a26cd9a2f0c50b$exports.renderLabel = function renderLabel(props) {
    var labelValue = $54a26cd9a2f0c50b$var$getLabelValue(props);
    if (!labelValue) return null;
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($cac1573991102b6d$exports.LabelWrapper, {
        children: labelValue
    });
};
var $54a26cd9a2f0c50b$var$getSize = $54a26cd9a2f0c50b$exports.getSize = function getSize(size, isGhost) {
    return !isGhost ? size : "ghost";
};



function $c06c31892548508b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $c06c31892548508b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c06c31892548508b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c06c31892548508b$var$_typeof(o);
}
function $c06c31892548508b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c06c31892548508b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c06c31892548508b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c06c31892548508b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c06c31892548508b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c06c31892548508b$var$_defineProperty(e, r, t) {
    return (r = $c06c31892548508b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c06c31892548508b$var$_toPropertyKey(t) {
    var i = $c06c31892548508b$var$_toPrimitive(t, "string");
    return "symbol" == $c06c31892548508b$var$_typeof(i) ? i : i + "";
}
function $c06c31892548508b$var$_toPrimitive(t, r) {
    if ("object" != $c06c31892548508b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c06c31892548508b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c06c31892548508b$var$Button = $c06c31892548508b$exports.Button = function Button(props) {
    var _props$id = props.id, id = _props$id === void 0 ? "" : _props$id, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, _props$colorStyle = props.colorStyle, colorStyle = _props$colorStyle === void 0 ? "primary" : _props$colorStyle, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, _props$disabledToolti = props.disabledTooltipText, disabledTooltipText = _props$disabledToolti === void 0 ? "" : _props$disabledToolti, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? true : _props$disableFocusRi, _props$isLoading = props.isLoading, isLoading = _props$isLoading === void 0 ? false : _props$isLoading, _props$classes = props.classes, classes = _props$classes === void 0 ? null : _props$classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$fullWidthOnMob = props.fullWidthOnMobile, fullWidthOnMobile = _props$fullWidthOnMob === void 0 ? false : _props$fullWidthOnMob, _props$dataTestid = props["data-testid"], dataTestId = _props$dataTestid === void 0 ? null : _props$dataTestid, _props$dataCy = props["data-cy"], dataCy = _props$dataCy === void 0 ? null : _props$dataCy, onClick = props.onClick, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$form = props.form, form = _props$form === void 0 ? null : _props$form;
    var isGhost = colorStyle === "ghost";
    var forceDisableAllRipple = isGhost || disabled;
    var componentId = id;
    var linkProps = {};
    var SingleButton = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($cac1573991102b6d$exports.Wrapper, {
        disabled: disabled,
        className: className,
        "data-testid": dataTestId,
        "data-cy": dataCy,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        children: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cac1573991102b6d$exports.StyledButton, $c06c31892548508b$var$_objectSpread($c06c31892548508b$var$_objectSpread({
            className: classes === null || classes === void 0 ? void 0 : classes.button,
            id: componentId,
            type: type,
            onClick: onClick,
            disabled: disabled,
            colorStyle: colorStyle,
            isLoading: isLoading,
            isGhost: isGhost,
            form: form,
            size: (0, $54a26cd9a2f0c50b$exports.getSize)(size, isGhost),
            disableRipple: forceDisableAllRipple || disableRipple,
            disableFocusRipple: forceDisableAllRipple || disableFocusRipple
        }, linkProps), {}, {
            children: [
                (0, $54a26cd9a2f0c50b$exports.renderLabel)(props),
                (0, $54a26cd9a2f0c50b$exports.renderIcon)(props)
            ]
        }), componentId)
    });
    if (disabled && disabledTooltipText) return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($ac782590520c5221$exports.ArrowToolTip, {
        title: disabledTooltipText,
        children: SingleButton
    });
    return SingleButton;
};



var $4bcf179a2fd6a129$var$_styledComponents = $4bcf179a2fd6a129$var$_interopRequireDefault($fQDDo$styledcomponents);
var $4bcf179a2fd6a129$var$_templateObject, $4bcf179a2fd6a129$var$_templateObject2, $4bcf179a2fd6a129$var$_templateObject3, $4bcf179a2fd6a129$var$_templateObject4, $4bcf179a2fd6a129$var$_templateObject5, $4bcf179a2fd6a129$var$_templateObject6;
function $4bcf179a2fd6a129$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4bcf179a2fd6a129$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $4bcf179a2fd6a129$var$Wrapper = $4bcf179a2fd6a129$exports.Wrapper = $4bcf179a2fd6a129$var$_styledComponents["default"].div($4bcf179a2fd6a129$var$_templateObject || ($4bcf179a2fd6a129$var$_templateObject = $4bcf179a2fd6a129$var$_taggedTemplateLiteral([
    "\n  display: flex;\n  flex-direction: column;\n\n  @media ",
    " {\n    flex-direction: row;\n  }\n"
])), function(props) {
    return props.theme.query.desktop;
});
var $4bcf179a2fd6a129$var$Content = $4bcf179a2fd6a129$exports.Content = $4bcf179a2fd6a129$var$_styledComponents["default"].div($4bcf179a2fd6a129$var$_templateObject2 || ($4bcf179a2fd6a129$var$_templateObject2 = $4bcf179a2fd6a129$var$_taggedTemplateLiteral([
    "\n  ",
    "\n  @media ",
    " {\n    display: flex;\n  }\n"
])), function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.query.min.tablet;
});
var $4bcf179a2fd6a129$var$Button = $4bcf179a2fd6a129$exports.Button = (0, $4bcf179a2fd6a129$var$_styledComponents["default"])($c06c31892548508b$exports.Button)($4bcf179a2fd6a129$var$_templateObject3 || ($4bcf179a2fd6a129$var$_templateObject3 = $4bcf179a2fd6a129$var$_taggedTemplateLiteral([
    "\n  width: 100%;\n  span:first-child {\n    text-transform: uppercase;\n  }\n\n  button {\n    width: 100%;\n  }\n"
])));
var $4bcf179a2fd6a129$var$Icon = $4bcf179a2fd6a129$exports.Icon = (0, $4bcf179a2fd6a129$var$_styledComponents["default"])($e970333371cd7b48$exports.PrivacyPolicyIcon)($4bcf179a2fd6a129$var$_templateObject4 || ($4bcf179a2fd6a129$var$_templateObject4 = $4bcf179a2fd6a129$var$_taggedTemplateLiteral([
    "\n  margin-right: 34px;\n  margin-bottom: 20px;\n\n  width: 45px;\n  height: 48px;\n  @media ",
    " {\n    min-width: 79px;\n    height: 86px;\n  }\n"
])), function(props) {
    return props.theme.query.desktop;
});
var $4bcf179a2fd6a129$var$Title = $4bcf179a2fd6a129$exports.Title = $4bcf179a2fd6a129$var$_styledComponents["default"].div($4bcf179a2fd6a129$var$_templateObject5 || ($4bcf179a2fd6a129$var$_templateObject5 = $4bcf179a2fd6a129$var$_taggedTemplateLiteral([
    "\n  ",
    "\n  ",
    "\n  @media ",
    " {\n    ",
    "\n    ",
    "\n  }\n"
])), function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.fontWeight.bold;
}, function(props) {
    return props.theme.query.desktop;
}, function(props) {
    return props.theme.typo.displayM;
}, function(props) {
    return props.theme.fontWeight.medium;
});
var $4bcf179a2fd6a129$var$Description = $4bcf179a2fd6a129$exports.Description = $4bcf179a2fd6a129$var$_styledComponents["default"].div($4bcf179a2fd6a129$var$_templateObject6 || ($4bcf179a2fd6a129$var$_templateObject6 = $4bcf179a2fd6a129$var$_taggedTemplateLiteral([
    "\n  ",
    "\n  margin-bottom: 20px;\n  margin-top: 5px;\n\n  @media ",
    " {\n    ",
    "\n    margin-top: 10px;\n    margin-bottom: 0px;\n  }\n\n  a {\n    color: ",
    ";\n    display: block;\n    @media ",
    " {\n      display: inline;\n      margin-left: 5px;\n    }\n  }\n"
])), function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.query.desktop;
}, function(props) {
    return props.theme.typo.bodyL;
}, function(props) {
    return props.theme.color.black;
}, function(props) {
    return props.theme.query.desktop;
});


var $040eb7b625ccb793$exports = {};
"use strict";
Object.defineProperty($040eb7b625ccb793$exports, "__esModule", {
    value: true
});
$040eb7b625ccb793$exports.handleOnAcceptOnlyNecessary = $040eb7b625ccb793$exports.handleOnAcceptAll = void 0;
var $040eb7b625ccb793$var$handleOnAcceptAll = $040eb7b625ccb793$exports.handleOnAcceptAll = function handleOnAcceptAll(onConfirm) {
    return function() {
        return onConfirm({
            necessary: true,
            performance: true,
            marketing: true
        });
    };
};
var $040eb7b625ccb793$var$handleOnAcceptOnlyNecessary = $040eb7b625ccb793$exports.handleOnAcceptOnlyNecessary = function handleOnAcceptOnlyNecessary(onConfirm) {
    return function() {
        return onConfirm({
            necessary: true,
            performance: false,
            marketing: false
        });
    };
};



var $a9067361c29dd1b9$var$_Icon;
function $a9067361c29dd1b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $a9067361c29dd1b9$var$CookieMessage = $a9067361c29dd1b9$exports.CookieMessage = function CookieMessage(_ref) {
    var title = _ref.title, description = _ref.description, cookiePolicyUrl = _ref.cookiePolicyUrl, cookiePolicyLabel = _ref.cookiePolicyLabel, acceptAllBtnText = _ref.acceptAllBtnText, acceptOnlyNecessaryBtnText = _ref.acceptOnlyNecessaryBtnText, onConfirm = _ref.onConfirm, managePreferencesBtnText = _ref.managePreferencesBtnText, onClickManagePreferences = _ref.onClickManagePreferences;
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($4bcf179a2fd6a129$exports.Wrapper, {
        children: [
            $a9067361c29dd1b9$var$_Icon || ($a9067361c29dd1b9$var$_Icon = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4bcf179a2fd6a129$exports.Icon, {})),
            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($4bcf179a2fd6a129$exports.Content, {
                children: [
                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                        container: true,
                        item: true,
                        xs: 12,
                        md: 9,
                        mdUpSpacingRight: 6,
                        children: [
                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4bcf179a2fd6a129$exports.Title, {
                                children: title
                            }),
                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($4bcf179a2fd6a129$exports.Description, {
                                children: [
                                    description,
                                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("a", {
                                        href: cookiePolicyUrl,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: cookiePolicyLabel
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                        container: true,
                        item: true,
                        xs: 12,
                        md: 3,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4bcf179a2fd6a129$exports.Button, {
                                    onClick: (0, $040eb7b625ccb793$exports.handleOnAcceptAll)(onConfirm),
                                    children: acceptAllBtnText
                                })
                            }),
                            acceptOnlyNecessaryBtnText && /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                                item: true,
                                xs: 12,
                                spacingTop: 4,
                                spacingBottom: 4,
                                children: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4bcf179a2fd6a129$exports.Button, {
                                    colorStyle: "secondary",
                                    onClick: (0, $040eb7b625ccb793$exports.handleOnAcceptOnlyNecessary)(onConfirm),
                                    children: acceptOnlyNecessaryBtnText
                                })
                            }),
                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4bcf179a2fd6a129$exports.Button, {
                                    colorStyle: "ghost",
                                    onClick: onClickManagePreferences,
                                    children: managePreferencesBtnText
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $35df4888ba419434$exports = {};
"use strict";
Object.defineProperty($35df4888ba419434$exports, "__esModule", {
    value: true
});
Object.defineProperty($35df4888ba419434$exports, "ManagePreferences", {
    enumerable: true,
    get: function get() {
        return $3ee7e536af787be6$exports.ManagePreferences;
    }
});
var $3ee7e536af787be6$exports = {};
"use strict";
function $3ee7e536af787be6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3ee7e536af787be6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3ee7e536af787be6$var$_typeof(o);
}
Object.defineProperty($3ee7e536af787be6$exports, "__esModule", {
    value: true
});
$3ee7e536af787be6$exports.ManagePreferences = void 0;

var $52b18866f643d7c5$exports = {};
"use strict";
Object.defineProperty($52b18866f643d7c5$exports, "__esModule", {
    value: true
});
Object.defineProperty($52b18866f643d7c5$exports, "Toggle", {
    enumerable: true,
    get: function get() {
        return $6ee22bdc11574301$exports.Toggle;
    }
});
var $6ee22bdc11574301$exports = {};
"use strict";
Object.defineProperty($6ee22bdc11574301$exports, "__esModule", {
    value: true
});
$6ee22bdc11574301$exports.Toggle = void 0;

var $6ee22bdc11574301$var$_react = $6ee22bdc11574301$var$_interopRequireDefault($fQDDo$react);
var $e3d0d6c51dd392ca$exports = {};
"use strict";
Object.defineProperty($e3d0d6c51dd392ca$exports, "__esModule", {
    value: true
});
$e3d0d6c51dd392ca$exports.TooltipUI = $e3d0d6c51dd392ca$exports.SwitchUI = $e3d0d6c51dd392ca$exports.Row = $e3d0d6c51dd392ca$exports.FormControlLabel = void 0;
var $0718c2d299c242fb$exports = {};
"use strict";
Object.defineProperty($0718c2d299c242fb$exports, "__esModule", {
    value: true
});
Object.defineProperty($0718c2d299c242fb$exports, "Tooltip", {
    enumerable: true,
    get: function get() {
        return $b96176e18943bdae$exports.Tooltip;
    }
});
var $b96176e18943bdae$exports = {};
"use strict";
function $b96176e18943bdae$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b96176e18943bdae$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b96176e18943bdae$var$_typeof(o);
}
Object.defineProperty($b96176e18943bdae$exports, "__esModule", {
    value: true
});
$b96176e18943bdae$exports.Tooltip = void 0;
var $6eaf8feaa4f1e890$exports = {};
"use strict";
Object.defineProperty($6eaf8feaa4f1e890$exports, "__esModule", {
    value: true
});
Object.defineProperty($6eaf8feaa4f1e890$exports, "TooltipIcon", {
    enumerable: true,
    get: function get() {
        return $9fcfd5855cb6f9cc$exports.TooltipIcon;
    }
});
var $9fcfd5855cb6f9cc$exports = {};
"use strict";
Object.defineProperty($9fcfd5855cb6f9cc$exports, "__esModule", {
    value: true
});
$9fcfd5855cb6f9cc$exports.TooltipIcon = void 0;

var $9fcfd5855cb6f9cc$var$_react = $9fcfd5855cb6f9cc$var$_interopRequireDefault($fQDDo$react);
var $0a22f83f96f4d6ea$exports = {};
"use strict";
Object.defineProperty($0a22f83f96f4d6ea$exports, "__esModule", {
    value: true
});
$0a22f83f96f4d6ea$exports.SvgIcon = void 0;

var $0a22f83f96f4d6ea$var$_styledComponents = $0a22f83f96f4d6ea$var$_interopRequireDefault($fQDDo$styledcomponents);

var $0a22f83f96f4d6ea$var$_SvgIcon = $0a22f83f96f4d6ea$var$_interopRequireDefault($fQDDo$muimaterialSvgIcon);
var $0a22f83f96f4d6ea$var$_templateObject;
function $0a22f83f96f4d6ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $0a22f83f96f4d6ea$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $0a22f83f96f4d6ea$var$SvgIcon = $0a22f83f96f4d6ea$exports.SvgIcon = (0, $0a22f83f96f4d6ea$var$_styledComponents["default"])($0a22f83f96f4d6ea$var$_SvgIcon["default"]).attrs(function() {
    return {
        fontSize: "inherit",
        classes: {
            root: "root"
        }
    };
})($0a22f83f96f4d6ea$var$_templateObject || ($0a22f83f96f4d6ea$var$_templateObject = $0a22f83f96f4d6ea$var$_taggedTemplateLiteral([
    "\n  &.root {\n    vertical-align: sub;\n  }\n"
])));



var $9fcfd5855cb6f9cc$var$_SvgIcon;
function $9fcfd5855cb6f9cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $9fcfd5855cb6f9cc$var$TooltipIcon = $9fcfd5855cb6f9cc$exports.TooltipIcon = function TooltipIcon() {
    return $9fcfd5855cb6f9cc$var$_SvgIcon || ($9fcfd5855cb6f9cc$var$_SvgIcon = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($0a22f83f96f4d6ea$exports.SvgIcon, {
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.6 15.2C11.7974 15.2 15.2 11.7974 15.2 7.6C15.2 3.40255 11.7974 0 7.6 0C3.40255 0 0 3.40255 0 7.6C0 11.7974 3.40255 15.2 7.6 15.2ZM7.6 13.8182C11.0343 13.8182 13.8182 11.0343 13.8182 7.6C13.8182 4.16566 11.0343 1.38182 7.6 1.38182C4.16566 1.38182 1.38182 4.16566 1.38182 7.6C1.38182 11.0343 4.16566 13.8182 7.6 13.8182ZM8.80909 4.32025C8.80909 4.60702 8.71058 4.85125 8.5129 5.05232C8.31589 5.25407 8.07839 5.3546 7.8004 5.3546C7.52174 5.3546 7.28356 5.25407 7.08386 5.05232C6.88482 4.85125 6.78562 4.60702 6.78562 4.32025C6.78562 4.03486 6.88481 3.78993 7.08386 3.58684C7.28289 3.38307 7.52175 3.28187 7.8004 3.28187C8.07839 3.28187 8.31589 3.38375 8.5129 3.58684C8.71058 3.78993 8.80909 4.03486 8.80909 4.32025ZM8.70991 11.1349C8.41372 11.2779 8.17622 11.3859 7.99943 11.4607C7.82266 11.5356 7.61755 11.5728 7.38341 11.5728C7.0238 11.5728 6.74446 11.4661 6.54474 11.2529C6.3457 11.0397 6.24583 10.7685 6.24583 10.4406C6.24583 10.3131 6.25325 10.1828 6.2681 10.0492C6.28362 9.91633 6.30723 9.76587 6.34029 9.59786L6.71138 8.0008C6.74444 7.84832 6.77278 7.70325 6.79505 7.56562C6.81799 7.43 6.82878 7.30451 6.82878 7.19182C6.82878 6.98738 6.79437 6.84502 6.72488 6.76471C6.65605 6.68442 6.5238 6.64394 6.32814 6.64394C6.23233 6.64394 6.13382 6.66283 6.03329 6.69927C5.93208 6.73503 5.87271 6.31063 5.87271 6.31063C6.1156 6.18986 6.34838 6.08729 6.57037 6.0016C6.79236 5.91592 7.00219 5.87273 7.20122 5.87273C7.55815 5.87273 7.83344 5.97799 8.02707 6.18782C8.22004 6.39765 8.3172 6.66958 8.3172 7.00558C8.3172 7.0744 8.31045 7.19721 8.29696 7.37196C8.28346 7.5467 8.2585 7.70729 8.22274 7.85371L7.853 9.44468C7.82264 9.5722 7.79565 9.71861 7.77203 9.88258C7.74774 10.0459 7.7356 10.1707 7.7356 10.2543C7.7356 10.4655 7.77473 10.6099 7.85232 10.6868C7.93059 10.7631 8.06486 10.8015 8.25647 10.8015C8.34621 10.8015 8.44877 10.782 8.56211 10.7442C8.67546 10.7057 8.70987 11.1348 8.70987 11.1348L8.70991 11.1349Z",
            fill: "#828282"
        })
    }));
};





var $b96176e18943bdae$var$_react = $b96176e18943bdae$var$_interopRequireDefault($fQDDo$react);
var $ea0bf9ed5333cd08$exports = {};
"use strict";
Object.defineProperty($ea0bf9ed5333cd08$exports, "__esModule", {
    value: true
});
$ea0bf9ed5333cd08$exports.stopEventPropagation = void 0;
var $ea0bf9ed5333cd08$var$stopEventPropagation = $ea0bf9ed5333cd08$exports.stopEventPropagation = function stopEventPropagation(event) {
    return event.stopPropagation();
};


var $64e5938adda1566b$exports = {};
"use strict";
function $64e5938adda1566b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $64e5938adda1566b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $64e5938adda1566b$var$_typeof(o);
}
Object.defineProperty($64e5938adda1566b$exports, "__esModule", {
    value: true
});
$64e5938adda1566b$exports.TooltipUI = $64e5938adda1566b$exports.Div = void 0;

var $64e5938adda1566b$var$_react = $64e5938adda1566b$var$_interopRequireDefault($fQDDo$react);

var $64e5938adda1566b$var$_styledComponents = $64e5938adda1566b$var$_interopRequireDefault($fQDDo$styledcomponents);

var $64e5938adda1566b$var$_Tooltip = $64e5938adda1566b$var$_interopRequireDefault($fQDDo$muimaterialTooltip);

var $64e5938adda1566b$var$_templateObject, $64e5938adda1566b$var$_templateObject2;
function $64e5938adda1566b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $64e5938adda1566b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64e5938adda1566b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64e5938adda1566b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $64e5938adda1566b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64e5938adda1566b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $64e5938adda1566b$var$_defineProperty(e, r, t) {
    return (r = $64e5938adda1566b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $64e5938adda1566b$var$_toPropertyKey(t) {
    var i = $64e5938adda1566b$var$_toPrimitive(t, "string");
    return "symbol" == $64e5938adda1566b$var$_typeof(i) ? i : i + "";
}
function $64e5938adda1566b$var$_toPrimitive(t, r) {
    if ("object" != $64e5938adda1566b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $64e5938adda1566b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $64e5938adda1566b$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $64e5938adda1566b$var$Div = $64e5938adda1566b$exports.Div = $64e5938adda1566b$var$_styledComponents["default"].div($64e5938adda1566b$var$_templateObject || ($64e5938adda1566b$var$_templateObject = $64e5938adda1566b$var$_taggedTemplateLiteral([
    "\n  display: inline-flex;\n  margin-left: 5px;\n  align-items: center;\n  &:hover {\n    cursor: help;\n  }\n"
])));
// Need to pass className prop to popper className because the tooltip
// is render outside of the current html node
var $64e5938adda1566b$var$TooltipUI = $64e5938adda1566b$exports.TooltipUI = (0, $64e5938adda1566b$var$_styledComponents["default"])(function(props) {
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($64e5938adda1566b$var$_Tooltip["default"], $64e5938adda1566b$var$_objectSpread({
        classes: {
            popper: props.className,
            tooltip: "tooltip",
            tooltipPlacementBottom: "tooltipPlacementBottom",
            tooltipPlacementRight: "tooltipPlacementRight",
            tooltipPlacementTop: "tooltipPlacementTop"
        }
    }, props));
})($64e5938adda1566b$var$_templateObject2 || ($64e5938adda1566b$var$_templateObject2 = $64e5938adda1566b$var$_taggedTemplateLiteral([
    "\n  & .tooltip {\n    ",
    ";\n    ",
    ";\n    ",
    ";\n    background-color: ",
    ";\n    border-radius: 4px;\n    color: ",
    ";\n    padding: 10px;\n    position: relative;\n\n    span {\n      &:before,\n      &:after {\n        background: ",
    ";\n      }\n    }\n  }\n"
])), function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.boxShadow.level2;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.color.g600;
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.g600;
});



var $b96176e18943bdae$var$_excluded = [
    "className",
    "placement",
    "open",
    "children",
    "tooltipEl"
];
function $b96176e18943bdae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $b96176e18943bdae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b96176e18943bdae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b96176e18943bdae$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b96176e18943bdae$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b96176e18943bdae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b96176e18943bdae$var$_defineProperty(e, r, t) {
    return (r = $b96176e18943bdae$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b96176e18943bdae$var$_toPropertyKey(t) {
    var i = $b96176e18943bdae$var$_toPrimitive(t, "string");
    return "symbol" == $b96176e18943bdae$var$_typeof(i) ? i : i + "";
}
function $b96176e18943bdae$var$_toPrimitive(t, r) {
    if ("object" != $b96176e18943bdae$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b96176e18943bdae$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b96176e18943bdae$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $b96176e18943bdae$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $b96176e18943bdae$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b96176e18943bdae$var$Tooltip = $b96176e18943bdae$exports.Tooltip = function Tooltip(props) {
    var _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottom" : _props$placement, open = props.open, children = props.children, _props$tooltipEl = props.tooltipEl, TooltipEl = _props$tooltipEl === void 0 ? $6eaf8feaa4f1e890$exports.TooltipIcon : _props$tooltipEl, rest = $b96176e18943bdae$var$_objectWithoutProperties(props, $b96176e18943bdae$var$_excluded);
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($64e5938adda1566b$exports.TooltipUI, $b96176e18943bdae$var$_objectSpread($b96176e18943bdae$var$_objectSpread({
        arrow: true
    }, rest), {}, {
        className: className,
        placement: placement,
        open: open,
        title: children,
        disableTouchListener: true,
        onClick: $ea0bf9ed5333cd08$exports.stopEventPropagation,
        children: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($64e5938adda1566b$exports.Div, {
            children: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)(TooltipEl, {})
        })
    }));
};






var $e3d0d6c51dd392ca$var$_styledComponents2 = $e3d0d6c51dd392ca$var$_interopRequireDefault($fQDDo$styledcomponents);

var $e3d0d6c51dd392ca$var$_FormControlLabel = $e3d0d6c51dd392ca$var$_interopRequireDefault($fQDDo$muimaterialFormControlLabel);

var $e3d0d6c51dd392ca$var$_Switch = $e3d0d6c51dd392ca$var$_interopRequireDefault($fQDDo$muimaterialSwitch);
var $e3d0d6c51dd392ca$var$_templateObject, $e3d0d6c51dd392ca$var$_templateObject2, $e3d0d6c51dd392ca$var$_templateObject3, $e3d0d6c51dd392ca$var$_templateObject4;
function $e3d0d6c51dd392ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $e3d0d6c51dd392ca$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $e3d0d6c51dd392ca$var$SwitchUI = $e3d0d6c51dd392ca$exports.SwitchUI = (0, $e3d0d6c51dd392ca$var$_styledComponents2["default"])($e3d0d6c51dd392ca$var$_Switch["default"]).attrs(function() {
    return {
        color: "primary",
        classes: {
            root: "root",
            thumb: "switch-thumb",
            track: "switch-track"
        }
    };
})($e3d0d6c51dd392ca$var$_templateObject || ($e3d0d6c51dd392ca$var$_templateObject = $e3d0d6c51dd392ca$var$_taggedTemplateLiteral([
    "\n  width: 30px;\n  height: 14px;\n  padding: 0;\n  display: flex;\n\n  &:active {\n    & .MuiSwitch-thumb {\n      width: 10px;\n    }\n    & .MuiSwitch-switchBase.Mui-checked {\n      /*! @noflip */\n      transform: translateX(15px);\n    }\n  }\n  & .MuiSwitch-switchBase {\n    padding: 2px;\n    &.Mui-checked {\n      /*! @noflip */\n      transform: translateX(15px);\n      color: #fff;\n      & + .MuiSwitch-track {\n        opacity: 1;\n        background-color: ",
    ";\n        border-color: ",
    ";\n      }\n\n      .MuiSwitch-thumb {\n        background-color: ",
    ";\n      }\n    }\n\n    &.Mui-disabled {\n      .MuiSwitch-thumb {\n        background-color: ",
    ";\n      }\n    }\n  }\n  & .MuiSwitch-thumb {\n    width: 10px;\n    height: 10px;\n    border-radius: 5px;\n    background-color: ",
    ";\n    ",
    ";\n  }\n\n  & .MuiSwitch-track {\n    border-radius: 8px;\n    opacity: 1;\n    background-color: ",
    ";\n    border: 1px solid ",
    ";\n    box-sizing: border-box;\n\n    ",
    "\n  }\n"
])), function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.theme.color.p500;
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.g300;
}, function(props) {
    return props.theme.color.g400;
}, function(props) {
    return props.theme.boxShadow.level2;
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.color.g400;
}, function(props) {
    return props.disabled && "border: 1px solid ".concat(props.theme.color.g200, "; opacity: 1;");
});
var $e3d0d6c51dd392ca$var$TooltipUI = $e3d0d6c51dd392ca$exports.TooltipUI = (0, $e3d0d6c51dd392ca$var$_styledComponents2["default"])($0718c2d299c242fb$exports.Tooltip)($e3d0d6c51dd392ca$var$_templateObject2 || ($e3d0d6c51dd392ca$var$_templateObject2 = $e3d0d6c51dd392ca$var$_taggedTemplateLiteral([
    "\n  ",
    ";\n  margin-left: 0;\n\n  ",
    " {\n    &.root {\n      vertical-align: middle;\n    }\n  }\n"
])), function(props) {
    return props.theme.typo.bodyL;
}, $0a22f83f96f4d6ea$exports.SvgIcon);
var $e3d0d6c51dd392ca$var$Row = $e3d0d6c51dd392ca$exports.Row = $e3d0d6c51dd392ca$var$_styledComponents2["default"].div($e3d0d6c51dd392ca$var$_templateObject3 || ($e3d0d6c51dd392ca$var$_templateObject3 = $e3d0d6c51dd392ca$var$_taggedTemplateLiteral([
    "\n  flex-direction: row;\n  display: flex;\n"
])));
var $e3d0d6c51dd392ca$var$FormControlLabel = $e3d0d6c51dd392ca$exports.FormControlLabel = (0, $e3d0d6c51dd392ca$var$_styledComponents2["default"])($e3d0d6c51dd392ca$var$_FormControlLabel["default"]).attrs(function() {
    return {
        classes: {
            root: "root",
            label: "label"
        }
    };
})($e3d0d6c51dd392ca$var$_templateObject4 || ($e3d0d6c51dd392ca$var$_templateObject4 = $e3d0d6c51dd392ca$var$_taggedTemplateLiteral([
    "\n  &.root {\n    margin-right: 5px;\n    margin-left: 0;\n  }\n\n  .label {\n    ",
    ";\n    ",
    ";\n    color: ",
    ";\n  }\n\n  &.MuiFormControlLabel-labelPlacementStart {\n    ",
    " {\n      margin-left: 8px;\n    }\n  }\n\n  &.MuiFormControlLabel-labelPlacementEnd {\n    ",
    " {\n      margin-right: 8px;\n    }\n  }\n"
])), function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.fontWeight.regular;
}, function(props) {
    return props.theme.color.g500;
}, $e3d0d6c51dd392ca$var$SwitchUI, $e3d0d6c51dd392ca$var$SwitchUI);



function $6ee22bdc11574301$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $6ee22bdc11574301$var$Toggle = $6ee22bdc11574301$exports.Toggle = function Toggle(props) {
    var _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, onOff = props.onOff, checked = props.checked, onChange = props.onChange, _props$label = props.label, label = _props$label === void 0 ? null : _props$label, _props$labelPlacement = props.labelPlacement, labelPlacement = _props$labelPlacement === void 0 ? "start" : _props$labelPlacement, _props$tooltip = props.tooltip, tooltip = _props$tooltip === void 0 ? null : _props$tooltip, _props$onLabel = props.onLabel, onLabel = _props$onLabel === void 0 ? "On" : _props$onLabel, _props$offLabel = props.offLabel, offLabel = _props$offLabel === void 0 ? "Off" : _props$offLabel;
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($e3d0d6c51dd392ca$exports.Row, {
        children: onOff ? /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($e3d0d6c51dd392ca$exports.FormControlLabel, {
            control: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($e3d0d6c51dd392ca$exports.FormControlLabel, {
                disabled: disabled,
                checked: checked,
                control: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($e3d0d6c51dd392ca$exports.SwitchUI, {
                    disabled: disabled
                }),
                label: onLabel,
                labelPlacement: "end"
            }),
            onChange: onChange,
            label: offLabel,
            labelPlacement: "start"
        }) : /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($fQDDo$reactjsxruntime.Fragment, {
            children: [
                /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($e3d0d6c51dd392ca$exports.FormControlLabel, {
                    disabled: disabled,
                    control: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($e3d0d6c51dd392ca$exports.SwitchUI, {
                        disabled: disabled
                    }),
                    checked: checked,
                    onChange: onChange,
                    label: label,
                    labelPlacement: labelPlacement
                }),
                tooltip && /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($e3d0d6c51dd392ca$exports.TooltipUI, {
                    children: tooltip
                })
            ]
        })
    });
};





var $3ee7e536af787be6$var$_react = $3ee7e536af787be6$var$_interopRequireWildcard($fQDDo$react);
var $4e618ca52ad9a2cc$exports = {};
"use strict";
Object.defineProperty($4e618ca52ad9a2cc$exports, "__esModule", {
    value: true
});
$4e618ca52ad9a2cc$exports.Wrapper = $4e618ca52ad9a2cc$exports.Title = $4e618ca52ad9a2cc$exports.Number = $4e618ca52ad9a2cc$exports.Icon = $4e618ca52ad9a2cc$exports.Description = $4e618ca52ad9a2cc$exports.CookieItem = $4e618ca52ad9a2cc$exports.Content = $4e618ca52ad9a2cc$exports.Button = $4e618ca52ad9a2cc$exports.AlwaysActive = void 0;



var $4e618ca52ad9a2cc$var$_styledComponents = $4e618ca52ad9a2cc$var$_interopRequireDefault($fQDDo$styledcomponents);
var $4e618ca52ad9a2cc$var$_templateObject, $4e618ca52ad9a2cc$var$_templateObject2, $4e618ca52ad9a2cc$var$_templateObject3, $4e618ca52ad9a2cc$var$_templateObject4, $4e618ca52ad9a2cc$var$_templateObject5, $4e618ca52ad9a2cc$var$_templateObject6, $4e618ca52ad9a2cc$var$_templateObject7, $4e618ca52ad9a2cc$var$_templateObject8, $4e618ca52ad9a2cc$var$_templateObject9;
function $4e618ca52ad9a2cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4e618ca52ad9a2cc$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $4e618ca52ad9a2cc$var$Wrapper = $4e618ca52ad9a2cc$exports.Wrapper = $4e618ca52ad9a2cc$var$_styledComponents["default"].div($4e618ca52ad9a2cc$var$_templateObject || ($4e618ca52ad9a2cc$var$_templateObject = $4e618ca52ad9a2cc$var$_taggedTemplateLiteral([
    "\n  display: flex;\n  flex-direction: column;\n\n  @media ",
    " {\n    flex-direction: row;\n  }\n"
])), function(props) {
    return props.theme.query.desktop;
});
var $4e618ca52ad9a2cc$var$AlwaysActive = $4e618ca52ad9a2cc$exports.AlwaysActive = $4e618ca52ad9a2cc$var$_styledComponents["default"].div($4e618ca52ad9a2cc$var$_templateObject2 || ($4e618ca52ad9a2cc$var$_templateObject2 = $4e618ca52ad9a2cc$var$_taggedTemplateLiteral([
    "\n  ",
    "\n  @media ",
    " {\n    ",
    "\n  }\n  ",
    "\n  text-transform: uppercase;\n  color: ",
    ";\n"
])), function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.query.desktop;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.color.p500;
});
var $4e618ca52ad9a2cc$var$Content = $4e618ca52ad9a2cc$exports.Content = $4e618ca52ad9a2cc$var$_styledComponents["default"].div($4e618ca52ad9a2cc$var$_templateObject3 || ($4e618ca52ad9a2cc$var$_templateObject3 = $4e618ca52ad9a2cc$var$_taggedTemplateLiteral([
    ""
])));
var $4e618ca52ad9a2cc$var$CookieItem = $4e618ca52ad9a2cc$exports.CookieItem = $4e618ca52ad9a2cc$var$_styledComponents["default"].div($4e618ca52ad9a2cc$var$_templateObject4 || ($4e618ca52ad9a2cc$var$_templateObject4 = $4e618ca52ad9a2cc$var$_taggedTemplateLiteral([
    "\n  span {\n    ",
    "\n    @media ",
    " {\n      ",
    "\n    }\n  }\n  ",
    "\n  @media ",
    " {\n    ",
    "\n  }\n"
])), function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.query.desktop;
}, function(props) {
    return props.theme.fontWeight.bold;
}, function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.query.desktop;
}, function(props) {
    return props.theme.typo.bodyL;
});
var $4e618ca52ad9a2cc$var$Number = $4e618ca52ad9a2cc$exports.Number = $4e618ca52ad9a2cc$var$_styledComponents["default"].div($4e618ca52ad9a2cc$var$_templateObject5 || ($4e618ca52ad9a2cc$var$_templateObject5 = $4e618ca52ad9a2cc$var$_taggedTemplateLiteral([
    "\n  margin-right: 5px;\n  width: 10px;\n  ",
    "\n  ",
    "\n\n  @media ",
    " {\n    ",
    "\n    ",
    "\n    width: unset;\n  }\n"
])), function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.query.desktop;
}, function(props) {
    return props.theme.fontWeight.bold;
}, function(props) {
    return props.theme.typo.bodyL;
});
var $4e618ca52ad9a2cc$var$Button = $4e618ca52ad9a2cc$exports.Button = (0, $4e618ca52ad9a2cc$var$_styledComponents["default"])($c06c31892548508b$exports.Button)($4e618ca52ad9a2cc$var$_templateObject6 || ($4e618ca52ad9a2cc$var$_templateObject6 = $4e618ca52ad9a2cc$var$_taggedTemplateLiteral([
    "\n  @media ",
    " {\n    width: 100%;\n\n    button {\n      width: 100%;\n    }\n  }\n"
])), function(props) {
    return props.theme.query.mobile;
});
var $4e618ca52ad9a2cc$var$Icon = $4e618ca52ad9a2cc$exports.Icon = (0, $4e618ca52ad9a2cc$var$_styledComponents["default"])($e970333371cd7b48$exports.PrivacyPolicyIcon)($4e618ca52ad9a2cc$var$_templateObject7 || ($4e618ca52ad9a2cc$var$_templateObject7 = $4e618ca52ad9a2cc$var$_taggedTemplateLiteral([
    "\n  @media ",
    " {\n    display: none;\n  }\n  margin-right: 34px;\n  min-width: 79px;\n  height: 86px;\n"
])), function(props) {
    return props.theme.query.mobile;
});
var $4e618ca52ad9a2cc$var$Title = $4e618ca52ad9a2cc$exports.Title = $4e618ca52ad9a2cc$var$_styledComponents["default"].div($4e618ca52ad9a2cc$var$_templateObject8 || ($4e618ca52ad9a2cc$var$_templateObject8 = $4e618ca52ad9a2cc$var$_taggedTemplateLiteral([
    "\n  ",
    "\n  ",
    "\n  @media ",
    " {\n    ",
    "\n    ",
    "\n  }\n"
])), function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.fontWeight.bold;
}, function(props) {
    return props.theme.query.desktop;
}, function(props) {
    return props.theme.typo.displayM;
}, function(props) {
    return props.theme.fontWeight.medium;
});
var $4e618ca52ad9a2cc$var$Description = $4e618ca52ad9a2cc$exports.Description = $4e618ca52ad9a2cc$var$_styledComponents["default"].div($4e618ca52ad9a2cc$var$_templateObject9 || ($4e618ca52ad9a2cc$var$_templateObject9 = $4e618ca52ad9a2cc$var$_taggedTemplateLiteral([
    "\n  ",
    "\n  margin-top: 5px;\n\n  @media ",
    " {\n    color: ",
    ";\n    ",
    "\n    ",
    "\n    margin-top: 10px;\n  }\n"
])), function(props) {
    return props.theme.typo.bodyS;
}, function(props) {
    return props.theme.query.desktop;
}, function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.theme.fontWeight.medium;
});


var $5eeb8f0d1cccc3f6$exports = {};
"use strict";
Object.defineProperty($5eeb8f0d1cccc3f6$exports, "__esModule", {
    value: true
});
$5eeb8f0d1cccc3f6$exports.handleOnConfirm = $5eeb8f0d1cccc3f6$exports.handleActiveCookies = void 0;
var $5eeb8f0d1cccc3f6$var$handleActiveCookies = $5eeb8f0d1cccc3f6$exports.handleActiveCookies = function handleActiveCookies(_ref) {
    var setIsActive = _ref.setIsActive, isActive = _ref.isActive;
    return function() {
        return setIsActive(!isActive);
    };
};
var $5eeb8f0d1cccc3f6$var$handleOnConfirm = $5eeb8f0d1cccc3f6$exports.handleOnConfirm = function handleOnConfirm(_ref2) {
    var isPerformanceCookiesActive = _ref2.isPerformanceCookiesActive, isMarketingCookiesActive = _ref2.isMarketingCookiesActive, onConfirm = _ref2.onConfirm;
    return function() {
        return onConfirm({
            necessary: true,
            performance: isPerformanceCookiesActive,
            marketing: isMarketingCookiesActive
        });
    };
};



var $3ee7e536af787be6$var$_Icon, $3ee7e536af787be6$var$_Number, $3ee7e536af787be6$var$_Number2, $3ee7e536af787be6$var$_Number3, $3ee7e536af787be6$var$_Number4, $3ee7e536af787be6$var$_Number5, $3ee7e536af787be6$var$_Number6;
function $3ee7e536af787be6$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3ee7e536af787be6$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3ee7e536af787be6$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $3ee7e536af787be6$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $3ee7e536af787be6$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3ee7e536af787be6$var$_slicedToArray(r, e) {
    return $3ee7e536af787be6$var$_arrayWithHoles(r) || $3ee7e536af787be6$var$_iterableToArrayLimit(r, e) || $3ee7e536af787be6$var$_unsupportedIterableToArray(r, e) || $3ee7e536af787be6$var$_nonIterableRest();
}
function $3ee7e536af787be6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3ee7e536af787be6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3ee7e536af787be6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3ee7e536af787be6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3ee7e536af787be6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3ee7e536af787be6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3ee7e536af787be6$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $3ee7e536af787be6$var$ManagePreferences = $3ee7e536af787be6$exports.ManagePreferences = function ManagePreferences(_ref) {
    var title = _ref.title, description = _ref.description, confirmBtnText = _ref.confirmBtnText, onConfirm = _ref.onConfirm, cookiesInfo = _ref.cookiesInfo, alwaysActiveText = _ref.alwaysActiveText;
    var _useState = (0, $3ee7e536af787be6$var$_react.useState)(false), _useState2 = $3ee7e536af787be6$var$_slicedToArray(_useState, 2), isPerformanceCookiesActive = _useState2[0], setIsPerformanceCookiesActive = _useState2[1];
    var _useState3 = (0, $3ee7e536af787be6$var$_react.useState)(false), _useState4 = $3ee7e536af787be6$var$_slicedToArray(_useState3, 2), isMarketingCookiesActive = _useState4[0], setIMarketingCookiesActive = _useState4[1];
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($4e618ca52ad9a2cc$exports.Wrapper, {
        children: [
            $3ee7e536af787be6$var$_Icon || ($3ee7e536af787be6$var$_Icon = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4e618ca52ad9a2cc$exports.Icon, {})),
            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($4e618ca52ad9a2cc$exports.Content, {
                children: [
                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4e618ca52ad9a2cc$exports.Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4e618ca52ad9a2cc$exports.Description, {
                        children: description
                    }),
                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                        container: true,
                        spacingTop: 4,
                        children: [
                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                                item: true,
                                container: true,
                                xs: 12,
                                md: 10,
                                wrap: "nowrap",
                                children: [
                                    $3ee7e536af787be6$var$_Number || ($3ee7e536af787be6$var$_Number = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4e618ca52ad9a2cc$exports.Number, {
                                        children: "".concat(1, ".")
                                    })),
                                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($4e618ca52ad9a2cc$exports.CookieItem, {
                                        children: [
                                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("span", {
                                                children: "".concat(cookiesInfo.necessary.title, " - ")
                                            }),
                                            cookiesInfo.necessary.description
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                                item: true,
                                container: true,
                                xs: 12,
                                md: 2,
                                mdUpJustify: "flex-end",
                                xsSpacingTop: 2,
                                children: [
                                    $3ee7e536af787be6$var$_Number2 || ($3ee7e536af787be6$var$_Number2 = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4e618ca52ad9a2cc$exports.Number, {})),
                                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4e618ca52ad9a2cc$exports.AlwaysActive, {
                                        children: alwaysActiveText
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                        container: true,
                        spacingTop: 4,
                        children: [
                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                                item: true,
                                container: true,
                                xs: 12,
                                md: 10,
                                wrap: "nowrap",
                                children: [
                                    $3ee7e536af787be6$var$_Number3 || ($3ee7e536af787be6$var$_Number3 = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4e618ca52ad9a2cc$exports.Number, {
                                        children: "".concat(2, ".")
                                    })),
                                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($4e618ca52ad9a2cc$exports.CookieItem, {
                                        children: [
                                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("span", {
                                                children: "".concat(cookiesInfo.performance.title, " - ")
                                            }),
                                            cookiesInfo.performance.description
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                                item: true,
                                container: true,
                                xs: 12,
                                md: 2,
                                mdUpJustify: "flex-end",
                                xsSpacingTop: 2,
                                children: [
                                    $3ee7e536af787be6$var$_Number4 || ($3ee7e536af787be6$var$_Number4 = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4e618ca52ad9a2cc$exports.Number, {})),
                                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($52b18866f643d7c5$exports.Toggle, {
                                        disabled: false,
                                        checked: isPerformanceCookiesActive,
                                        onChange: (0, $5eeb8f0d1cccc3f6$exports.handleActiveCookies)({
                                            isActive: isPerformanceCookiesActive,
                                            setIsActive: setIsPerformanceCookiesActive
                                        }),
                                        onOff: false,
                                        label: ""
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                        container: true,
                        spacingTop: 4,
                        spacingBottom: 4,
                        children: [
                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                                item: true,
                                container: true,
                                xs: 12,
                                md: 10,
                                wrap: "nowrap",
                                children: [
                                    $3ee7e536af787be6$var$_Number5 || ($3ee7e536af787be6$var$_Number5 = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4e618ca52ad9a2cc$exports.Number, {
                                        children: "".concat(3, ".")
                                    })),
                                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($4e618ca52ad9a2cc$exports.CookieItem, {
                                        children: [
                                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)("span", {
                                                children: "".concat(cookiesInfo.marketing.title, " - ")
                                            }),
                                            cookiesInfo.marketing.description
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($cc328f81773e9021$exports.Grid, {
                                item: true,
                                container: true,
                                xs: 12,
                                md: 2,
                                mdUpJustify: "flex-end",
                                xsSpacingTop: 2,
                                children: [
                                    $3ee7e536af787be6$var$_Number6 || ($3ee7e536af787be6$var$_Number6 = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4e618ca52ad9a2cc$exports.Number, {})),
                                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($52b18866f643d7c5$exports.Toggle, {
                                        disabled: false,
                                        checked: isMarketingCookiesActive,
                                        onChange: (0, $5eeb8f0d1cccc3f6$exports.handleActiveCookies)({
                                            isActive: isMarketingCookiesActive,
                                            setIsActive: setIMarketingCookiesActive
                                        }),
                                        onOff: false,
                                        label: ""
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($cc328f81773e9021$exports.Grid, {
                        container: true,
                        justifyContent: "flex-end",
                        children: /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4e618ca52ad9a2cc$exports.Button, {
                            onClick: (0, $5eeb8f0d1cccc3f6$exports.handleOnConfirm)({
                                isPerformanceCookiesActive: isPerformanceCookiesActive,
                                isMarketingCookiesActive: isMarketingCookiesActive,
                                onConfirm: onConfirm
                            }),
                            children: confirmBtnText
                        })
                    })
                ]
            })
        ]
    });
};





var $1286104da1c1ef10$var$_react = $1286104da1c1ef10$var$_interopRequireWildcard($fQDDo$react);

var $1286104da1c1ef10$var$_Backdrop = $1286104da1c1ef10$var$_interopRequireDefault($fQDDo$muimaterialBackdrop);
var $54c63f4f8ee185a8$exports = {};
"use strict";
Object.defineProperty($54c63f4f8ee185a8$exports, "__esModule", {
    value: true
});
$54c63f4f8ee185a8$exports.Wrapper = void 0;

var $54c63f4f8ee185a8$var$_styledComponents = $54c63f4f8ee185a8$var$_interopRequireDefault($fQDDo$styledcomponents);
var $54c63f4f8ee185a8$var$_templateObject;
function $54c63f4f8ee185a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $54c63f4f8ee185a8$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $54c63f4f8ee185a8$var$Wrapper = $54c63f4f8ee185a8$exports.Wrapper = $54c63f4f8ee185a8$var$_styledComponents["default"].div($54c63f4f8ee185a8$var$_templateObject || ($54c63f4f8ee185a8$var$_templateObject = $54c63f4f8ee185a8$var$_taggedTemplateLiteral([
    "\n  position: fixed;\n  max-height: calc(100vh - 50px);\n  overflow: auto;\n  z-index: ",
    ";\n  bottom: 14px;\n  width: auto;\n  padding: 20px;\n  border-radius: 15px;\n  background: ",
    ";\n  ",
    ";\n\n  &.slideLeft {\n    transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out;\n    opacity: 0;\n    transform: translateX(-100%);\n    left: auto;\n    right: auto;\n  }\n\n  &.slideLeft.enter {\n    transition: opacity 0.5s ease-in-out 0.3s,\n      transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.3s;\n    opacity: 1;\n    transform: translateX(0);\n    left: 14px;\n    right: 14px;\n  }\n\n  @media ",
    " {\n    padding: 40px;\n    max-width: 1105px;\n    margin: 0 auto;\n    bottom: 24px;\n    border-radius: 10px;\n  }\n"
])), function(props) {
    return props.$layerIndex;
}, function(props) {
    return props.theme.color.white;
}, function(props) {
    return props.theme.boxShadow.level5;
}, function(props) {
    return props.theme.query.desktop;
});


var $3614adb50b7dfe64$exports = {};
"use strict";
Object.defineProperty($3614adb50b7dfe64$exports, "__esModule", {
    value: true
});
$3614adb50b7dfe64$exports.handleOnClickManagePreferences = void 0;
var $3614adb50b7dfe64$var$handleOnClickManagePreferences = $3614adb50b7dfe64$exports.handleOnClickManagePreferences = function handleOnClickManagePreferences(setIsManagePreferencesOpen) {
    return function() {
        setIsManagePreferencesOpen(true);
    };
};



function $1286104da1c1ef10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $1286104da1c1ef10$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($1286104da1c1ef10$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $1286104da1c1ef10$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $1286104da1c1ef10$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $1286104da1c1ef10$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $1286104da1c1ef10$var$_slicedToArray(r, e) {
    return $1286104da1c1ef10$var$_arrayWithHoles(r) || $1286104da1c1ef10$var$_iterableToArrayLimit(r, e) || $1286104da1c1ef10$var$_unsupportedIterableToArray(r, e) || $1286104da1c1ef10$var$_nonIterableRest();
}
function $1286104da1c1ef10$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1286104da1c1ef10$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1286104da1c1ef10$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1286104da1c1ef10$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1286104da1c1ef10$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1286104da1c1ef10$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $1286104da1c1ef10$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $1286104da1c1ef10$var$AcceptCookiesModal = $1286104da1c1ef10$exports.AcceptCookiesModal = function AcceptCookiesModal(_ref) {
    var _ManagePreferences;
    var isOpen = _ref.isOpen, _ref$layerIndex = _ref.layerIndex, layerIndex = _ref$layerIndex === void 0 ? 9999 : _ref$layerIndex, title = _ref.title, description = _ref.description, cookiePolicyUrl = _ref.cookiePolicyUrl, cookiePolicyLabel = _ref.cookiePolicyLabel, acceptAllBtnText = _ref.acceptAllBtnText, acceptOnlyNecessaryBtnText = _ref.acceptOnlyNecessaryBtnText, managePreferencesBtnText = _ref.managePreferencesBtnText, managePreferencesTitle = _ref.managePreferencesTitle, managePreferencesDescription = _ref.managePreferencesDescription, confirmMyChoicesBtnText = _ref.confirmMyChoicesBtnText, alwaysActiveText = _ref.alwaysActiveText, cookiesInfo = _ref.cookiesInfo, onAccept = _ref.onAccept;
    var _useState = (0, $1286104da1c1ef10$var$_react.useState)(false), _useState2 = $1286104da1c1ef10$var$_slicedToArray(_useState, 2), isManagePreferencesOpen = _useState2[0], setIsManagePreferencesOpen = _useState2[1];
    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsxs)($fQDDo$reactjsxruntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($4162ea33faa774c7$exports.VisibilitySensor, {
                once: true,
                partialVisibility: true,
                children: function children(_ref2) {
                    var isVisible = _ref2.isVisible;
                    return /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($54c63f4f8ee185a8$exports.Wrapper, {
                        className: isVisible && isOpen ? "slideLeft enter" : "slideLeft",
                        $layerIndex: layerIndex,
                        children: isManagePreferencesOpen ? _ManagePreferences || (_ManagePreferences = /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($35df4888ba419434$exports.ManagePreferences, {
                            title: managePreferencesTitle,
                            description: managePreferencesDescription,
                            confirmBtnText: confirmMyChoicesBtnText,
                            alwaysActiveText: alwaysActiveText,
                            onConfirm: onAccept,
                            cookiesInfo: cookiesInfo
                        })) : /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($ce2faf26ff7c2977$exports.CookieMessage, {
                            title: title,
                            description: description,
                            cookiePolicyUrl: cookiePolicyUrl,
                            cookiePolicyLabel: cookiePolicyLabel,
                            acceptAllBtnText: acceptAllBtnText,
                            acceptOnlyNecessaryBtnText: acceptOnlyNecessaryBtnText,
                            managePreferencesBtnText: managePreferencesBtnText,
                            onConfirm: onAccept,
                            onClickManagePreferences: (0, $3614adb50b7dfe64$exports.handleOnClickManagePreferences)(setIsManagePreferencesOpen)
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0, $fQDDo$reactjsxruntime.jsx)($1286104da1c1ef10$var$_Backdrop["default"], {
                "data-testid": "accept-cookies-backdrop",
                open: isOpen,
                style: {
                    zIndex: layerIndex - 1
                }
            })
        ]
    });
};




//# sourceMappingURL=index.js.map
